import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64: { input: string; output: string; }
  /** An 8-bit signed integer */
  Byte: { input: any; output: any; }
  /** A custom scalar that handles byte arrays (Byte[] and byte[]) as an array of integers. */
  ByteArray: { input: any; output: any; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: string; output: string; }
  /** Duration scalar: '<number>[s|m|h|d]' or '<number>' (seconds by default) */
  Duration: { input: any; output: any; }
  /** LocalDateTime as GraphQL scalar. */
  LocalDateTime: { input: string; output: string; }
  /** A 64-bit signed integer */
  Long: { input: number; output: number; }
  /** A 16-bit signed integer */
  Short: { input: any; output: any; }
  /** A universally unique identifier compliant UUID Scalar */
  UUID: { input: string; output: string; }
}

export enum AccountType {
  Card = 'CARD',
  Rko = 'RKO'
}

export interface ApiKey {
  __typename?: 'ApiKey';
  apiKeyAccessList: Array<ApiKeyAccess>;
  /**  Список допустимых api */
  createdDate: Scalars['LocalDateTime']['output'];
  validUntil: Scalars['LocalDateTime']['output'];
}

export interface ApiKeyAccess {
  __typename?: 'ApiKeyAccess';
  api: Scalars['String']['output'];
}

export interface ApiKeyAccessInput {
  api: Scalars['String']['input'];
}

export enum AuthState {
  /**  CONFIRMED - пользователь подтверждён 2fa и установлен постоянный пароль */
  Confirmed = 'CONFIRMED',
  /**  INIT - первичная регистрация (установлен временный пароль) */
  Init = 'INIT'
}

export enum BdoState {
  Completed = 'COMPLETED',
  InProcess = 'IN_PROCESS',
  Rejected = 'REJECTED'
}

/**  Типы блокировок */
export enum BlockType {
  /**  PASSWORD - блокировка по паролю */
  Password = 'PASSWORD',
  /**  SMS - блокировка sms токена */
  Sms = 'SMS',
  /**  TOTP - блокировка totp токена */
  Totp = 'TOTP'
}

export interface BruteForcePolicyType {
  __typename?: 'BruteForcePolicyType';
  attempt: Scalars['Int']['output'];
  attemptOrder: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  lockDuration: Scalars['Int']['output'];
}

export interface CashAccessDetails {
  __typename?: 'CashAccessDetails';
  cashCode: Maybe<Scalars['Long']['output']>;
  cashName: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
}

export interface CcrAddressInput {
  administrativeArea2: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['String']['input']>;
  locality: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Scalars['String']['input']>;
  postalCode: InputMaybe<Scalars['String']['input']>;
  route: InputMaybe<Scalars['String']['input']>;
  streetNumber: InputMaybe<Scalars['String']['input']>;
  taxAuthorityDepartmentCode: InputMaybe<Scalars['Int']['input']>;
}

export interface CcrInput {
  address: InputMaybe<CcrAddressInput>;
  businessActivity: InputMaybe<Scalars['Int']['input']>;
  calcItemAttributes: InputMaybe<Array<Scalars['Int']['input']>>;
  ccrRegistrationNumber: InputMaybe<Scalars['String']['input']>;
  entrepreneurshipObject: InputMaybe<Scalars['Int']['input']>;
  salePointId: Scalars['Long']['input'];
  storeName: InputMaybe<Scalars['String']['input']>;
  taxAuthorityDepartment: InputMaybe<Scalars['Int']['input']>;
  taxSystems: InputMaybe<Array<Scalars['Short']['input']>>;
  updateReasons: InputMaybe<Array<Scalars['Int']['input']>>;
  vatPayer: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ChangeContactsRecord {
  __typename?: 'ChangeContactsRecord';
  /**  null - если не было изменений */
  email: Maybe<Scalars['String']['output']>;
  /**  null - если не было изменений */
  mobile: Maybe<Scalars['String']['output']>;
}

export interface CommonTask {
  __typename?: 'CommonTask';
  companyName: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['LocalDateTime']['output'];
  /**  Номер заявки */
  documentNumber: Maybe<Scalars['String']['output']>;
  /**  ID группы задач */
  groupId: Maybe<Scalars['UUID']['output']>;
  /**  Флаг наличия ошибок в дочерних подзадачах */
  hasChildErrors: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  taskState: TaskStates;
  transitId: Scalars['UUID']['output'];
  type: TaskType;
  updatedBy: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['LocalDateTime']['output'];
  userName: Maybe<Scalars['String']['output']>;
}

export enum CommunicationChannelPurpose {
  General = 'GENERAL',
  Swift = 'SWIFT'
}

export enum ContactType {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
  Phone = 'PHONE',
  SmsMobile = 'SMS_MOBILE',
  Telegram = 'TELEGRAM',
  Vk = 'VK',
  Whatsapp = 'WHATSAPP'
}

export interface ContactsChangesTask {
  __typename?: 'ContactsChangesTask';
  companyName: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['LocalDateTime']['output'];
  id: Scalars['UUID']['output'];
  newValue: ChangeContactsRecord;
  oldValue: ChangeContactsRecord;
  reason: Scalars['String']['output'];
  taskState: TaskStates;
  transitId: Scalars['UUID']['output'];
  type: TaskType;
  updatedDate: Scalars['LocalDateTime']['output'];
  userName: Maybe<Scalars['String']['output']>;
}

export interface Contract {
  __typename?: 'Contract';
  active: Scalars['Boolean']['output'];
  communicationChannels: Array<ContractCommunicationChannel>;
  companyName: Scalars['String']['output'];
  contractNum: Scalars['String']['output'];
  contractState: ContractState;
  createdDate: Scalars['Date']['output'];
  departmentCode: Scalars['String']['output'];
  departmentName: Scalars['String']['output'];
  expirationDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  inn: Scalars['String']['output'];
  /**  Признак цифрового контракта, если контракт создан онлайн - true */
  isDigital: Scalars['Boolean']['output'];
  orgReferenceId: Scalars['Long']['output'];
  payControlKey: Maybe<PayControlKey>;
  products: Array<ProductContractProjection>;
  reason: Maybe<Scalars['String']['output']>;
  ruTokenCert: Maybe<Scalars['String']['output']>;
  signScheme: SignScheme;
  signType: SignType;
  /**  Атрибуты сотрудника и договора, мб null если вызывается вне контекста сотрудника */
  userContractAttributes: Maybe<UserContractAttributes>;
}

export interface ContractCommunicationChannel {
  __typename?: 'ContractCommunicationChannel';
  contact: Scalars['String']['output'];
  contactType: ContactType;
  id: Scalars['UUID']['output'];
  isVerified: Scalars['Boolean']['output'];
  purposes: Array<CommunicationChannelPurpose>;
}

export interface ContractCommunicationChannelChangeInput {
  channelId: InputMaybe<Scalars['UUID']['input']>;
  contact: InputMaybe<Scalars['String']['input']>;
  contactType: InputMaybe<ContactType>;
  operation: ContractCommunicationChannelChangeOperation;
  purposes: InputMaybe<Array<CommunicationChannelPurpose>>;
}

export enum ContractCommunicationChannelChangeOperation {
  Add = 'ADD',
  Delete = 'DELETE',
  Edit = 'EDIT'
}

export enum ContractState {
  /**  ACTIVE */
  Active = 'ACTIVE',
  /**  AWAITING_ACTIVATION */
  AwaitingActivation = 'AWAITING_ACTIVATION',
  /**  AWAITING_BLOCKING */
  AwaitingBlocking = 'AWAITING_BLOCKING',
  /**  AWAITING_CHANGE */
  AwaitingChange = 'AWAITING_CHANGE',
  /**  BLOCKED */
  Blocked = 'BLOCKED',
  /**  DRAFT */
  Draft = 'DRAFT',
  /**  VERDICT_CHOICE */
  VerdictChoice = 'VERDICT_CHOICE'
}

export interface CreateCashDto {
  /**
   * ID кассы, созданной в модуле торговых точек. Это опциональный параметр,
   * если требуется новая касса - не заполнять данное поле!
   *
   * Ошибки:
   * CashRegisterNotFoundException - ошибка eсли id кассы не существует;
   */
  cashId: InputMaybe<Scalars['Long']['input']>;
  /**
   * ID торговой точки для которой создается касса
   *
   * Источник - сервис ob-sale-point
   */
  salePointId: Scalars['Long']['input'];
}

export interface CreateCashierTaskDetails {
  __typename?: 'CreateCashierTaskDetails';
  cashierFullName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  salePoints: Array<SalePointAccessDetails>;
  signRight: SignRight;
}

export interface CreateCashiersByLinkTask {
  __typename?: 'CreateCashiersByLinkTask';
  createdDate: Scalars['LocalDateTime']['output'];
  id: Scalars['UUID']['output'];
  newValue: CreateCashierTaskDetails;
  taskState: TaskStates;
  transitId: Scalars['UUID']['output'];
  type: TaskType;
  updatedBy: Scalars['String']['output'];
  updatedDate: Scalars['LocalDateTime']['output'];
}

/**  Объект для настройки ККМ  */
export interface CreateCcrTaskDto {
  /**  Код вида деятельности ККМ  */
  businessActivityCode: Scalars['Int']['input'];
  /**  Признак предмета расчёта  */
  calcItemAttributeCodes: Array<Scalars['Int']['input']>;
  /**
   * Объект для создания нового кассового узла.
   * Если указан cashId будет выбрана соответсвующая касса.
   */
  createCash: CreateCashDto;
  /** Номер документа 'ГГ/НННН' */
  documentNumber: Scalars['String']['input'];
  /**  Объект предпринимательства  */
  entrepreneurshipObjectCode: Scalars['Int']['input'];
  /**  Наименование ККМ/Кассы  */
  name: Scalars['String']['input'];
  /**  ID организации, референс юр лица  */
  orgReferenceId: Scalars['Long']['input'];
}

export interface CreatedApiKey {
  __typename?: 'CreatedApiKey';
  apiKeyAccessList: Array<ApiKeyAccess>;
  key: Scalars['UUID']['output'];
  validUntil: Scalars['LocalDateTime']['output'];
}

export interface DefaultTaxRateInput {
  /**  Код предмета расчета  */
  calcItemAttributeCode: Scalars['Short']['input'];
  /**  Тип дефолтной ставки  */
  productType: DefaultTaxRateType;
  /**  Процентная ставка по нал НСП  */
  stCashRate: Scalars['Short']['input'];
  /**  Процентная ставка по безнал НСП  */
  stCashlessRate: Scalars['Short']['input'];
  /**  Процентная ставка НДС  */
  vatRate: Scalars['Short']['input'];
}

export enum DefaultTaxRateType {
  /** Продажа товаров и услуг */
  Buy = 'BUY',
  /**  Товар */
  Good = 'GOOD',
  /** Услуга */
  Service = 'SERVICE'
}

export interface DefaultTaxRateUpdateInput {
  defaultTaxRateDtoList: InputMaybe<Array<InputMaybe<DefaultTaxRateInput>>>;
  orgReferenceId: Scalars['Long']['input'];
}

/**  Объект для заявки на удаление учетной записи ПККМ-POS  */
export interface DeletePkkmPosAccountTaskInput {
  /**  ID организации, референс юр лица  */
  orgReferenceId: Scalars['Long']['input'];
  /**  ID терминала  */
  terminalId: Scalars['Long']['input'];
}

export enum Direction {
  /**  ASC */
  Asc = 'ASC',
  /**  DESC */
  Desc = 'DESC'
}

/**  Объект для применения изменений */
export interface EditTask {
  /**  Данные для обновления задачи(Опциональное поле, надо закинуть null -> если это просто загрузка документа) */
  newValue: InputMaybe<Scalars['String']['input']>;
  /**  Документ прикрепляющийся к задаче */
  taskDocuments: InputMaybe<Array<TaskDocument>>;
  /**  Айди задачи */
  taskId: Scalars['UUID']['input'];
  /**  Тип задачи */
  taskType: TaskType;
}

export interface Employee {
  __typename?: 'Employee';
  authState: AuthState;
  createdDate: Scalars['LocalDateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  /**  Типы блокировок по bruteforce */
  employeeBlocks: Array<EmployeeBlocks>;
  enabled: Scalars['Boolean']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /**  Способ идентификации клиента */
  identificationType: IdentificationType;
  individualInn: Scalars['String']['output'];
  isResident: Scalars['Boolean']['output'];
  mobile: Scalars['String']['output'];
  /**  Состояние пост проверки по файлам ИП */
  postVerificationStatus: VerificationStatus;
  shortName: Scalars['String']['output'];
  /**  Признак временной или постоянной блокировки токенов, если блокировн хотя-бы один будет выведен false */
  tokensEnabled: Maybe<Scalars['Boolean']['output']>;
  userContracts: Array<Contract>;
  userReferenceId: Scalars['Long']['output'];
}

export interface EmployeeBlocks {
  __typename?: 'EmployeeBlocks';
  /**  Количество неуспешных попыток ввода */
  attempts: Scalars['Int']['output'];
  /**  Тип блокировки */
  blockType: BlockType;
  /**  Активен ли указанный тип блокировки */
  enabled: Scalars['Boolean']['output'];
  /**  Признак постоянной блокировки */
  isPermanentLockout: Scalars['Boolean']['output'];
  /**  Время разблокировки, если null - блокировка отсутствует либо токен в постоянной блокировке */
  unlockTime: Maybe<Scalars['LocalDateTime']['output']>;
}

export interface EmployeeContract {
  __typename?: 'EmployeeContract';
  businessUserContractId: Scalars['UUID']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  individualInn: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  referenceId: Scalars['Long']['output'];
  registrationState: RegistrationStates;
  shortName: Scalars['String']['output'];
  signRight: SignRight;
  signType: SignType;
  userContractState: UserContractState;
}

export interface EnrollmentToken {
  __typename?: 'EnrollmentToken';
  email: Maybe<Scalars['String']['output']>;
  failCount: Scalars['Int']['output'];
  lastAuthMatch: Scalars['String']['output'];
  lastAuthSuccess: Scalars['String']['output'];
  maxFail: Scalars['Int']['output'];
  phone: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
  tokenDescription: Scalars['String']['output'];
  tokenType: TokenType;
}

export enum FileCodeType {
  CertificateIp = 'CERTIFICATE_IP',
  License = 'LICENSE'
}

export interface FileData {
  __typename?: 'FileData';
  base64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
}

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

/**  Способ идентификации клиента */
export enum IdentificationType {
  /**  Одноразовый код */
  Otp = 'OTP',
  /**  УИВК */
  Rpv = 'RPV'
}

/**  Сущность физ лица */
export interface IndividualPerson {
  __typename?: 'IndividualPerson';
  fullName: Scalars['String']['output'];
  individualInn: Scalars['String']['output'];
  isResident: Scalars['Boolean']['output'];
  shortName: Scalars['String']['output'];
  userReferenceId: Scalars['Long']['output'];
}

export interface InputBruteForcePolicyDto {
  /**  Начало */
  attempt: Scalars['Int']['input'];
  /**  Порядок блокировки */
  attemptOrder: Scalars['Int']['input'];
  /**  Тип блокировки */
  blockType: BlockType;
  /**  Id политики */
  id: Scalars['Long']['input'];
  /**  Время блокировки */
  lockDuration: Scalars['Int']['input'];
}

export interface InputCreateContractDto {
  companyName: Scalars['String']['input'];
  /**  Список сотрудников */
  createEmployees: InputMaybe<Array<InputCreateEmployeeDto>>;
  /**  Уникальный код подразделения/филиала */
  departmentCode: Scalars['Long']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  /**  Срок истечения договора */
  expDate: Scalars['Date']['input'];
  fullName: Scalars['String']['input'];
  individualInn: Scalars['String']['input'];
  inn: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  /**  Определяет уникальную ссылку организации, юр лица */
  orgReferenceId: Scalars['Long']['input'];
  /**  Определяет уникальную ссылку, сотрудника организации физ лица */
  referenceId: Scalars['Long']['input'];
  shortName: Scalars['String']['input'];
  /**  Способ подписания документа */
  significationType: SignType;
}

export interface InputCreateEmployeeDto {
  /**  Id договора, необязателен в случае создания договора */
  contractId: InputMaybe<Scalars['UUID']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  individualInn: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  /**  Определяет уникальную ссылку, сотрудника организации физ лица */
  referenceId: Scalars['Long']['input'];
  shortName: Scalars['String']['input'];
  /**  Право подписания документа */
  significationRight: SignRight;
}

export interface InputCreateRuTokenCert {
  certId: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
}

/**  Парметры пагинации, для постраничного вывода данных */
export interface InputPageable {
  /**  Направление сортировки */
  direction: Direction;
  /**  Номер страницы, начинается с нуля */
  pageNumber: Scalars['Int']['input'];
  /**  Количество данных на одной странице */
  pageSize: Scalars['Int']['input'];
  /**  Список полей по которым выполняется сортировка, наименования полей брать в ответных объектах */
  sortFields: Array<Scalars['String']['input']>;
}

export interface InputUserContractActivityToChange {
  state: UserContractState;
  /**  Id отношений business user и contract (см. UserContractAttributes) */
  userContractId: Scalars['UUID']['input'];
}

export interface InputUserInfoRecord {
  /**  Тип клиента - 0 физик, 1 юрик, игнорировать это поле! */
  clientType: InputMaybe<Scalars['Int']['input']>;
  /**  Подразделение, игнорировать это поле! */
  depCode: InputMaybe<Scalars['String']['input']>;
  docNumber: Scalars['String']['input'];
  docSeries: Scalars['String']['input'];
  individualInn: Scalars['String']['input'];
  locationId: Scalars['Long']['input'];
  mobile: Scalars['String']['input'];
}

export interface LoanEmployeeState {
  __typename?: 'LoanEmployeeState';
  list: Array<OnLoanEmployeeState>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface MarketInfoInput {
  containerName: InputMaybe<Scalars['String']['input']>;
  marketName: InputMaybe<Scalars['String']['input']>;
  row: InputMaybe<Scalars['String']['input']>;
}

/** Если задача охватыает только одну подзадачу -> остальные подзадачи указывать как null. */
export interface MassUpdateCcrInput {
  ccrs: InputMaybe<Array<UpdateCcrSettings>>;
  /**  уникальный бизнес-номер, формата 'YY:NNN' который создает перед печатью */
  documentNumber: InputMaybe<Scalars['String']['input']>;
  orgReferenceId: Scalars['Long']['input'];
  organizationProfileDto: InputMaybe<OrganizationProfileInput>;
  salePoints: InputMaybe<Array<SalePointTaskInput>>;
}

export interface Mutation {
  __typename?: 'Mutation';
  /**  Заявка на ПОС-терминал */
  POSApplicationTask: Scalars['UUID']['output'];
  activateContract: Scalars['Boolean']['output'];
  /**  Метод добавление администратора/продавца рассрочки со стороны EFR */
  addLoanRolesTask: Scalars['UUID']['output'];
  /**  Метод добавление продавца рассрочки */
  addSellerRoleFromUserTask: Scalars['UUID']['output'];
  blockContract: Scalars['Boolean']['output'];
  /**  Метод на изменения политик блокировки */
  changeBruteForcePolicy: Scalars['Boolean']['output'];
  /**  Смена кодового слова */
  changeCodeword: Scalars['Boolean']['output'];
  changeContractCommunicationChannels: Scalars['UUID']['output'];
  /**  Метод изменения филиала */
  changeDepartmentTask: Scalars['UUID']['output'];
  /**  Метод изменения роли продавца рассрочек на администратора со стороны EFR */
  changeLoanRoleTask: Scalars['UUID']['output'];
  /**  Метод изменения сертификата RuToken со стороны EFR */
  changeRuTokenCertTask: Scalars['UUID']['output'];
  /**  Метод блокировки/разблокировки сотрудника в компании */
  changeUserActivityInCompanyTask: Scalars['UUID']['output'];
  /**  Метод изменения состояния пользователя */
  changeUserActivityTask: Scalars['UUID']['output'];
  changeUserContractActivity: Array<UserContractActivityToChange>;
  changeUserContractContactsTask: Scalars['UUID']['output'];
  changeUserContractSignRightTask: Scalars['UUID']['output'];
  changeUserContractSignTypeTask: Scalars['UUID']['output'];
  /**  Создание офлайн сессии для пользователя */
  createApiKey: CreatedApiKey;
  createBusinessUser: User;
  /**  Метод создания упрощенца с ролью продавца рассрочек */
  createBusinessUserContractWithRoleSellerTask: Scalars['UUID']['output'];
  /**
   * Заявка на создание ККМ, возвращает id созданной задачи
   *
   * NotAvailableCalcItemAttribute - код предмета расчета недоступен
   * EntrepreneurshipObjectCodeNotFound - Объект предпринимательства не найден
   * CalcItemAttributeCodeNotFound - код предмета расчета недоступен не найден
   * CcrAlreadyExistsException - для данной кассы уже есть ККМ
   */
  createCcrTask: Scalars['UUID']['output'];
  /**
   * Заявка на удаление учетной записи ПККМ-POS, возвращает id созданной задачи.
   * Задача создаётся в состоянии ON_ADJUSTMENT; документ загружается через editTasks.
   *
   * Ошибки:
   * DuplicateTaskTypeOfOrgOnIllegalState - для данного терминала уже существует активная заявка
   * InvalidTaskDocumentMimeType - файл не является допустимым изображением (при editTasks)
   */
  createDeletePkkmPosAccountTask: Scalars['UUID']['output'];
  /**
   * Создание задачи на редактирование дефолтных ставок.
   * Возвращает айди задачи.
   *
   * Ошибки:
   * ShiftIsNotClosedException - классификатор ошибки, если есть открытая смена при создании заявки.
   * DefaultTaxRateCompareException - если комбинация для дефолтных ставок не соответствуют данным в справочнике.
   * DuplicateTaskTypeOfOrgOnIllegalState - у организации уже существует задача на верификации с таким типом.
   */
  createEditingDefaultTaxRatesTask: Scalars['UUID']['output'];
  createEmployee: Array<Maybe<User>>;
  /**
   * Сохраняет markdown-шаблоны задачи на подписи, проверяет их по JSON-схеме и возвращает готовый markdown.
   * Для PayControl после сохранения запускает отправку на подпись.
   * Ошибки GraphQL:
   * IllegalStateException - задача не в ON_SIGNATURE, либо у договора нет организации или типа подписи
   * IllegalArgumentException - тип задачи не поддерживает подпись
   * SigningStartupException - неподдерживаемый тип подписи, шаблон не прошёл проверку или не удалось собрать markdown
   * BusinessUserContractsException - для POS не найден контракт пользователя
   * ContractException - для зарплатной задачи не найден договор
   */
  createMarkdown: TaskSigningPayload;
  /**
   * Создание задачи на массовое редактирование ККМ.
   * Возвращает идентификатор группы задач.
   *
   * Правила заполнения входных данных:
   * - Поля заполняются только в случае наличия изменений.
   * - Если в объекте или массиве отсутствуют изменения — поле должно быть передано как null.
   * - Если изменения в данных торговой точки (ТТ) или налогоплательщика (НП)
   * приводят к необходимости обновления ККМ, массив `ccrs` ОБЯЗАТЕЛЕН
   * и должен содержать только те ККМ, которые относятся к соответствующим ТТ и НП.
   *
   * Ошибки:
   * ShiftIsNotClosedException - классификатор ошибки, если есть открытая смена при создании заявки.
   * BalanceMustBeNull - баланс должен быть нулевым, если это -> перерегистрация/снятие с учета/изменение базовых ставок
   * TaxSystemCodeNotFound - ошибка, Код налогового режима не найден
   * CcrIsDeregistered - ККМ снята с учета
   * DuplicateTaskTypeOfOrgOnIllegalState - если у организации уже есть таска на статус ON_VERIFICATION
   * с таким же типом
   * ExistOrgProfileUpdateTask - существует задача по изменению НП, при изменении ККМ
   * ExistSalePointEditingTaskOnVerificaton - на данную торговую точку есть не подтвержденная задача
   * на редактирование!
   * CcrMigrationToSalePointTaskAlreadyExist - есть задача на верификации где ККМ переходит на данную ТТ
   * TaxAuthorityDepartmentsNotFound - сервис OB_CCR не вернул значения УГНС
   * InvalidTaxModeVatCombination - Для выбранного налогового режима невозможно установить НДС = TRUE,
   * НДС доступен только для общего налогового режима.
   * InvalidTaxSystemInput - Поля taxSystemCode и isVatPayer должны быть заполнены вместе
   * CcrEditingAlreadyOnVerification - ККМ находится на верификации, невозможно создать задачу
   * CcrMustBeNonNull - обязательно указать ККМ налогоплательщика
   * InvalidCcrBusinessActivityCode - код вида деятельности ККМ не входит в список НП
   * или ККМ не указана при смене видов деятельности налогоплательщика
   * DuplicateCcrInMassUpdateInput - в заявке указана одна и та же ККМ несколько раз
   * InvalidCcrBusinessActivityCode - неправильно заполнены виды деятельности
   * CcrMustBeNonNull - в НП затронуты поля при перерегистрации, которые требуют заполнения ККМ
   * CcrRequiredForSalePointChange - при изменении адресных/налоговых полей ТТ в заявке должны быть указаны все
   * действующие ККМ этой ТТ
   * DuplicateSalePointIdInMassUpdateInput - не должно быть дубликатов ТТ по айди
   * DuplicateSalePointCodeInMassUpdateInput - не должно быть дубликатов ТТ по коду
   */
  createMassEditingCcrTask: Scalars['UUID']['output'];
  createPayControlKey: PayControlCreateKey;
  /**  Выпуск PayControl, ключ в формате json. Для мобилки */
  createPayControlKeyAsJson: PayControlCreateKey;
  /**  Метод создания сертификата RuToken со стороны EFR */
  createRuTokenCertTask: Scalars['UUID']['output'];
  /**  Удаление ключа PayControl */
  deletePayControlKey: PayControlKey;
  /**  Метод удаления сертификата RuToken со стороны EFR */
  deleteRuTokenCertTask: Scalars['UUID']['output'];
  /**
   * Редактирование списка задач.
   *
   * TaskHashMismatch - хеш документа из запроса не совпадает с хешем в БД
   */
  editTasks: Array<Scalars['UUID']['output']>;
  /**
   * Генерирует уникальный бизнес-номер заявки для печатных документов.
   *
   * Формат: 'YY/NNN', где:
   * - YY — последние две цифры календарного года
   * - NNN — сквозной порядковый номер заявки в рамках года(счетчик нумерации)
   *
   * Номер:
   * - генерируется до сохранения заявки в базе данных
   * - гарантированно уникален в рамках года
   * - одинаков для всех подзадач одной заявки
   * - не является техническим идентификатором заявки
   *
   * С началом нового календарного года используется отдельный счётчик нумерации.
   * Пропуски в нумерации допустимы и считаются корректными.
   */
  generateTaskNumber: Scalars['String']['output'];
  /**
   * Предоставление доступа к кассе для текущего юзера
   * <p> Возвращает id компании
   *
   * <p> Ошибки:
   * <p> WrongRoleException - Пользователь должен иметь роль кассира
   * <p> AlreadyHasAccessToCashesException - Юзер уже привязан к кассам
   */
  openAccessToCashTask: Scalars['Long']['output'];
  /**  Заявка на пайду */
  payDaApplicationTask: Scalars['UUID']['output'];
  regeneratePayControlKey: PayControlCreateKey;
  /**  Выпуск нового ключа PayControl, ключ в формате json. Для мобилки */
  regeneratePayControlKeyAsJson: PayControlCreateKey;
  /**  Метод удаления ролей пользователя со стороны EFR */
  removeLoanRolesTask: Scalars['UUID']['output'];
  /**  Метод удаления роли продавца рассрочек */
  removeSellerRolesFromUserTask: Scalars['UUID']['output'];
  /**  Метод обновления пароля и доставки его по смс, состояние договора и пользователя не меняется */
  renewPasswordAndSendTask: Scalars['UUID']['output'];
  resetFailCounter: Scalars['Boolean']['output'];
  /**
   *  ID компании
   *  Сохранение настроек ограничений задач
   */
  saveTaskConstraint: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  setVerdict: Scalars['Boolean']['output'];
  /**  Настройка способа идентификации клиента */
  switchIdentificationTypeTask: Scalars['UUID']['output'];
  /**
   * Настройка доступа продукта к организации
   * BankProductDisallowedException - некорректный продукт
   * TaskRejectedException - при отсутствии или уже существовании доступа к продукту
   */
  switchProductContractPolicy: Scalars['UUID']['output'];
  /**  Настроить доступ к продукту */
  switchProductRolePolicy: Scalars['UUID']['output'];
  toVerificationBusinessUserContract: Scalars['Boolean']['output'];
  /**  Метод разблокировки двухфакторной аутентификации */
  unlock2FATask: Scalars['UUID']['output'];
  uploadSoleTraderFiles: Scalars['Boolean']['output'];
  /**  Метод изменения сертификата RuToken со стороны клиента */
  userChangeRuTokenCertTask: Scalars['UUID']['output'];
  /**  Метод создания сертификата RuToken со стороны клиента */
  userCreateRuTokenCertTask: Scalars['UUID']['output'];
  /**  Принудительное отклонение исполненной заявки */
  userDeclineTask: Scalars['Boolean']['output'];
  verdict: Scalars['Boolean']['output'];
  /**
   * Метод подтверждения группы задач, данный метод всегда возвращает TRUE или ошибку, никогда не вернет FALSE,
   * задача или создается, или с ошибкой остается на верификации.
   */
  verdictForGroupTask: Scalars['Boolean']['output'];
  /**
   * Метод подтверждения задач
   * Ошибки:
   * SalePointIntegrationException - если ошибка при попытке сохранить счет ТТ.
   */
  verdictForTask: Scalars['Boolean']['output'];
}


export interface MutationPosApplicationTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  posApplication: PosApplication;
  signature: InputMaybe<PosSignatureInput>;
}


export interface MutationActivateContractArgs {
  contractId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}


export interface MutationAddLoanRolesTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  productRoleEnum: ProductRoleEnum;
}


export interface MutationAddSellerRoleFromUserTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  otpCode: Scalars['String']['input'];
}


export interface MutationBlockContractArgs {
  contractId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}


export interface MutationChangeBruteForcePolicyArgs {
  bruteForcePolicyDto: Array<InputBruteForcePolicyDto>;
}


export interface MutationChangeCodewordArgs {
  codeword: Scalars['String']['input'];
  vgHash: Scalars['UUID']['input'];
}


export interface MutationChangeContractCommunicationChannelsArgs {
  changes: Array<ContractCommunicationChannelChangeInput>;
  contractId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}


export interface MutationChangeDepartmentTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  newDepartment: InputMaybe<Scalars['Long']['input']>;
  reason: Scalars['String']['input'];
}


export interface MutationChangeLoanRoleTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  productRoleEnum: ProductRoleEnum;
  reason: Scalars['String']['input'];
}


export interface MutationChangeRuTokenCertTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  newRuTokenCert: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  ruTokenCertId: Scalars['Long']['input'];
}


export interface MutationChangeUserActivityInCompanyTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
  stateEnum: UserContractState;
}


export interface MutationChangeUserActivityTaskArgs {
  enabled: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
}


export interface MutationChangeUserContractActivityArgs {
  toChange: Array<InputUserContractActivityToChange>;
}


export interface MutationChangeUserContractContactsTaskArgs {
  businessUserId: Scalars['UUID']['input'];
  newEmail: InputMaybe<Scalars['String']['input']>;
  newMobile: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
}


export interface MutationChangeUserContractSignRightTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  newSignRight: SignRight;
  reason: Scalars['String']['input'];
}


export interface MutationChangeUserContractSignTypeTaskArgs {
  contractId: Scalars['UUID']['input'];
  newSignType: SignType;
  reason: Scalars['String']['input'];
}


export interface MutationCreateApiKeyArgs {
  apiKeyAccessList: Array<ApiKeyAccessInput>;
  orgReferenceId: Scalars['Long']['input'];
  password: Scalars['String']['input'];
}


export interface MutationCreateBusinessUserArgs {
  createContract: InputCreateContractDto;
}


export interface MutationCreateBusinessUserContractWithRoleSellerTaskArgs {
  orgReferenceId: Scalars['Long']['input'];
  userInfo: InputUserInfoRecord;
}


export interface MutationCreateCcrTaskArgs {
  createCcrInput: CreateCcrTaskDto;
}


export interface MutationCreateDeletePkkmPosAccountTaskArgs {
  input: DeletePkkmPosAccountTaskInput;
}


export interface MutationCreateEditingDefaultTaxRatesTaskArgs {
  defaultTaxRatesUpdateInput: DefaultTaxRateUpdateInput;
}


export interface MutationCreateEmployeeArgs {
  employees: Array<InputCreateEmployeeDto>;
}


export interface MutationCreateMarkdownArgs {
  markdownTemplates: Array<Scalars['String']['input']>;
  taskId: Scalars['UUID']['input'];
}


export interface MutationCreateMassEditingCcrTaskArgs {
  massUpdateCcrInput: InputMaybe<MassUpdateCcrInput>;
}


export interface MutationCreatePayControlKeyArgs {
  orgReferenceId: Scalars['Long']['input'];
  otpCode: Scalars['String']['input'];
}


export interface MutationCreatePayControlKeyAsJsonArgs {
  keyEncryptionPassword: Scalars['String']['input'];
  orgReferenceId: Scalars['Long']['input'];
}


export interface MutationCreateRuTokenCertTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  newRuTokenCert: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}


export interface MutationDeletePayControlKeyArgs {
  orgReferenceId: Scalars['Long']['input'];
}


export interface MutationDeleteRuTokenCertTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
  ruTokenCertId: Scalars['Long']['input'];
}


export interface MutationEditTasksArgs {
  tasksForEditing: Array<EditTask>;
}


export interface MutationOpenAccessToCashTaskArgs {
  linkId: Scalars['UUID']['input'];
}


export interface MutationPayDaApplicationTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  payDaApplication: PayDaApplicationDto;
}


export interface MutationRegeneratePayControlKeyArgs {
  orgReferenceId: Scalars['Long']['input'];
  otpCode: Scalars['String']['input'];
}


export interface MutationRegeneratePayControlKeyAsJsonArgs {
  keyEncryptionPassword: Scalars['String']['input'];
  orgReferenceId: Scalars['Long']['input'];
}


export interface MutationRemoveLoanRolesTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}


export interface MutationRemoveSellerRolesFromUserTaskArgs {
  orgReferenceId: Scalars['Long']['input'];
  otpCode: Scalars['String']['input'];
}


export interface MutationRenewPasswordAndSendTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}


export interface MutationResetFailCounterArgs {
  serial: Scalars['String']['input'];
}


export interface MutationSaveTaskConstraintArgs {
  taskConstraints: Array<TaskConstraintInput>;
}


export interface MutationSetVerdictArgs {
  contractId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  verdict: Scalars['Boolean']['input'];
}


export interface MutationSwitchIdentificationTypeTaskArgs {
  identificationType: IdentificationType;
  reason: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
}


export interface MutationSwitchProductContractPolicyArgs {
  contractId: Scalars['UUID']['input'];
  product: ProductEnum;
  reason: InputMaybe<Scalars['String']['input']>;
  switchAccess: Scalars['Boolean']['input'];
}


export interface MutationSwitchProductRolePolicyArgs {
  businessUserContractId: Scalars['UUID']['input'];
  productRole: ProductRoleEnum;
  switchAccess: Scalars['Boolean']['input'];
}


export interface MutationToVerificationBusinessUserContractArgs {
  businessUserContractId: Scalars['UUID']['input'];
}


export interface MutationUnlock2FaTaskArgs {
  reason: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
}


export interface MutationUploadSoleTraderFilesArgs {
  files: Array<UpdateFiles>;
  orgReferenceId: Scalars['Long']['input'];
}


export interface MutationUserChangeRuTokenCertTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  newRuTokenCert: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  ruTokenCertId: Scalars['Long']['input'];
}


export interface MutationUserCreateRuTokenCertTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  ruTokenCert: InputCreateRuTokenCert;
}


export interface MutationUserDeclineTaskArgs {
  taskId: Scalars['UUID']['input'];
}


export interface MutationVerdictArgs {
  contractId: Scalars['UUID']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
  verdict: Scalars['Boolean']['input'];
}


export interface MutationVerdictForGroupTaskArgs {
  reason: InputMaybe<Scalars['String']['input']>;
  taskGroupId: Scalars['UUID']['input'];
  taskIdForReload: InputMaybe<Scalars['UUID']['input']>;
  verdict: Scalars['Boolean']['input'];
}


export interface MutationVerdictForTaskArgs {
  reason: InputMaybe<Scalars['String']['input']>;
  signature: InputMaybe<PosSignatureInput>;
  taskId: Scalars['UUID']['input'];
  verdict: Scalars['Boolean']['input'];
}

export interface OnLoanEmployeeState {
  __typename?: 'OnLoanEmployeeState';
  createdDate: Scalars['String']['output'];
  fullName: Maybe<Scalars['String']['output']>;
  individualInn: Maybe<Scalars['String']['output']>;
  locationId: Scalars['Long']['output'];
  reason: Scalars['String']['output'];
  referenceId: Maybe<Scalars['Long']['output']>;
  taskState: TaskStates;
  updatedDate: Scalars['String']['output'];
}

export interface OnVerificationContract {
  __typename?: 'OnVerificationContract';
  companyName: Scalars['String']['output'];
  contractNum: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  departmentId: Scalars['Long']['output'];
  departmentName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  inn: Scalars['String']['output'];
  orgReferenceId: Scalars['Long']['output'];
  reason: Maybe<Scalars['String']['output']>;
  state: ContractState;
  updatedBy: Scalars['String']['output'];
  updatedDate: Scalars['LocalDateTime']['output'];
}

export interface OnVerificationEmployee {
  __typename?: 'OnVerificationEmployee';
  companyName: Scalars['String']['output'];
  contractId: Scalars['UUID']['output'];
  contractNum: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  departmentId: Scalars['Long']['output'];
  departmentName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  expirationDate: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  /**  ИНН физ лица */
  individualInn: Scalars['String']['output'];
  /**  ИНН организации */
  inn: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  openDate: Scalars['Date']['output'];
  orgReferenceId: Scalars['Long']['output'];
  referenceId: Scalars['Long']['output'];
  registrationState: RegistrationStates;
  shortName: Scalars['String']['output'];
  signRight: SignRight;
  updatedBy: Scalars['String']['output'];
  userContractState: UserContractState;
  userId: Scalars['UUID']['output'];
}

/**  TODO сохранение данных с наименованиями */
export interface OrganizationProfileInput {
  /**  Список видов деятельности  */
  businessActivityCodes: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**  Плательщик НДС  */
  isVatPayer: InputMaybe<Scalars['Boolean']['input']>;
  /**  ID организации, референс юр лица  */
  orgReferenceId: Scalars['Long']['input'];
  /**  Налоговый режим  */
  taxSystemCode: InputMaybe<Scalars['Short']['input']>;
  taxSystemsInput: InputMaybe<TaxSystemsInput>;
}

export interface PosApplication {
  /**  Вид счета (Р/С / Бизнес-карта) */
  accountType: InputMaybe<AccountType>;
  /**  Фактический адрес предприятия */
  actualAddress: InputMaybe<Scalars['String']['input']>;
  /**  Обратная сторона паспорта */
  backPhoto: InputMaybe<Scalars['Base64']['input']>;
  /**  Счет */
  clientAccount: InputMaybe<Scalars['String']['input']>;
  /**  Адрес проживания ответственного (контактное) лица торговой точки */
  clientContactAddress: InputMaybe<Scalars['String']['input']>;
  /**  ФИО ответственного (контактное) лица торговой точки */
  clientContactName: InputMaybe<Scalars['String']['input']>;
  /**  Номер телефона ответственного (контактное) лица торговой точки */
  clientContactNumber: InputMaybe<Scalars['String']['input']>;
  /**  Лицевая сторона паспорта */
  frontPhoto: InputMaybe<Scalars['Base64']['input']>;
  /**  Наличие ККМ в заказе */
  hasClientKkm: InputMaybe<Scalars['Boolean']['input']>;
  /**  Наличие видеокамер или охраны */
  hasSecurity: InputMaybe<Scalars['Boolean']['input']>;
  /**  Юридический адрес предприятия */
  legalAddress: InputMaybe<Scalars['String']['input']>;
  /**  Основной вид деятельности предприятия */
  mainActivity: InputMaybe<Scalars['String']['input']>;
  /**  Виды товаров и/или услуг, реализуемых торговой точкой */
  offerTypes: InputMaybe<Scalars['String']['input']>;
  /**  Адрес торговой точки */
  storeAddress: InputMaybe<Scalars['String']['input']>;
  /**  Название торговой точки */
  storeName: InputMaybe<Scalars['String']['input']>;
  /**  Количество POS терминала на заказ */
  terminalsCount: InputMaybe<Scalars['Short']['input']>;
  /**  Режим работы */
  workingDays: InputMaybe<Scalars['String']['input']>;
}

export interface PosApplicationTaskType {
  __typename?: 'POSApplicationTaskType';
  companyName: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['LocalDateTime']['output'];
  id: Scalars['UUID']['output'];
  newValue: PosApplicationType;
  oldValue: PosApplicationType;
  reason: Scalars['String']['output'];
  taskState: TaskStates;
  transitId: Scalars['UUID']['output'];
  type: TaskType;
  updatedDate: Scalars['LocalDateTime']['output'];
  userName: Maybe<Scalars['String']['output']>;
}

export interface PosApplicationType {
  __typename?: 'POSApplicationType';
  /**  Вид счета (Р/С / Бизнес-карта) */
  accountType: Maybe<AccountType>;
  /**  Фактический адрес предприятия */
  actualAddress: Maybe<Scalars['String']['output']>;
  /**  Обратная сторона паспорта */
  backPhoto: Maybe<Scalars['Base64']['output']>;
  /**  Состояние из бдо */
  bdoState: Maybe<BdoState>;
  /**  Счет */
  clientAccount: Maybe<Scalars['String']['output']>;
  /**  Адрес проживания ответственного (контактное) лица торговой точки */
  clientContactAddress: Maybe<Scalars['String']['output']>;
  /**  ФИО ответственного (контактное) лица торговой точки */
  clientContactName: Maybe<Scalars['String']['output']>;
  /**  Номер телефона ответственного (контактное) лица торговой точки */
  clientContactNumber: Maybe<Scalars['String']['output']>;
  /**  Лицевая сторона паспорта */
  frontPhoto: Maybe<Scalars['Base64']['output']>;
  /**  Наличие ККМ в заказе */
  hasClientKkm: Maybe<Scalars['Boolean']['output']>;
  /**  Наличие видеокамер или охраны */
  hasSecurity: Maybe<Scalars['Boolean']['output']>;
  /**  Юридический адрес предприятия */
  legalAddress: Maybe<Scalars['String']['output']>;
  /**  Основной вид деятельности предприятия */
  mainActivity: Maybe<Scalars['String']['output']>;
  /**  Виды товаров и/или услуг, реализуемых торговой точкой */
  offerTypes: Maybe<Scalars['String']['output']>;
  /**  Причина отклонения */
  rejectReason: Maybe<Scalars['String']['output']>;
  /**  Адрес торговой точки */
  storeAddress: Maybe<Scalars['String']['output']>;
  /**  Название торговой точки */
  storeName: Maybe<Scalars['String']['output']>;
  /**  Количество POS терминала на заказ */
  terminalsCount: Maybe<Scalars['Short']['output']>;
  /**  Режим работы */
  workingDays: Maybe<Scalars['String']['output']>;
}

export interface PosSignatureInput {
  markdownTemplate: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
  signedData: InputMaybe<Scalars['String']['input']>;
}

/**  Information about pagination in a connection. */
export interface PageInfo {
  __typename?: 'PageInfo';
  /**  When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /**  When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /**  When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /**  When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
}

export interface PageOnCommonTask {
  __typename?: 'PageOnCommonTask';
  list: Array<CommonTask>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface PageOnCreateCashierByLinkTask {
  __typename?: 'PageOnCreateCashierByLinkTask';
  list: Array<CreateCashiersByLinkTask>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface PageOnPosApplicationTask {
  __typename?: 'PageOnPOSApplicationTask';
  list: Array<PosApplicationTaskType>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface PageOnVerificationContracts {
  __typename?: 'PageOnVerificationContracts';
  list: Array<OnVerificationContract>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface PageOnVerificationEmployees {
  __typename?: 'PageOnVerificationEmployees';
  list: Array<OnVerificationEmployee>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface PageUserContractType {
  __typename?: 'PageUserContractType';
  list: Array<Contract>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface PayControlCreateKey {
  __typename?: 'PayControlCreateKey';
  expirationDate: Scalars['LocalDateTime']['output'];
  key: Maybe<Scalars['String']['output']>;
  pcUserId: Scalars['String']['output'];
  qr: Scalars['String']['output'];
  status: Scalars['String']['output'];
  username: Scalars['String']['output'];
}

export interface PayControlExportKeyResponse {
  __typename?: 'PayControlExportKeyResponse';
  expirationDate: Scalars['String']['output'];
  expirationTimestamp: Scalars['String']['output'];
  extAuthAvailableMethods: Array<Scalars['String']['output']>;
  keyFlags: Scalars['String']['output'];
  keyIndex: Scalars['String']['output'];
  keyJson: Scalars['String']['output'];
  systemId: Scalars['String']['output'];
  systemName: Scalars['String']['output'];
  systemSettings: PayControlSystemSettings;
  userId: Scalars['String']['output'];
}

export interface PayControlKey {
  __typename?: 'PayControlKey';
  expirationDate: Scalars['LocalDateTime']['output'];
  pcUserId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  username: Scalars['String']['output'];
}

export interface PayControlKeyAvailability {
  __typename?: 'PayControlKeyAvailability';
  available: Scalars['Boolean']['output'];
  nonAvailableFor: Array<Maybe<ShortUser>>;
  orgReferenceId: Scalars['Long']['output'];
}

export interface PayControlSystemSettings {
  __typename?: 'PayControlSystemSettings';
  authCodeTimeSamplingInterval: Scalars['String']['output'];
  confirmCodeTimeSamplingInterval: Scalars['String']['output'];
}

export interface PayDaApplicationDto {
  contactFullName: Scalars['String']['input'];
  contactMobile: Scalars['String']['input'];
  orgReferenceId: Scalars['Long']['input'];
}

export interface PcDetails {
  __typename?: 'PcDetails';
  appId: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  expirationDate: Scalars['LocalDateTime']['output'];
  orgReferenceId: Scalars['String']['output'];
  pcUserId: Scalars['String']['output'];
  systemId: Scalars['String']['output'];
}

export interface PosContract {
  __typename?: 'PosContract';
  companyName: Scalars['String']['output'];
  contractNum: Scalars['String']['output'];
  contractState: ContractState;
  createdDate: Scalars['Date']['output'];
  departmentCode: Scalars['String']['output'];
  departmentName: Scalars['String']['output'];
  expirationDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  inn: Scalars['String']['output'];
  orgReferenceId: Scalars['Long']['output'];
  products: Array<ProductContractProjection>;
  signScheme: SignScheme;
  signType: SignType;
}

export interface PosTerminal {
  __typename?: 'PosTerminal';
  /**  Данные компании пос терминала */
  contract: PosContract;
  /**  Поле для обратной совместимости */
  fullName: Scalars['String']['output'];
  /**  ID в учётной системе */
  id: Scalars['UUID']['output'];
  /**  Поле для обратной совместимости */
  shortName: Scalars['String']['output'];
  /**  Номер терминала */
  terminalCode: Scalars['String']['output'];
}

export interface ProcessFileInput {
  /**  base64 файла */
  documentBase64: Scalars['String']['input'];
  /**  Наименование файла */
  fileName: Scalars['String']['input'];
}

export interface ProcessedFileResponse {
  __typename?: 'ProcessedFileResponse';
  /**  Хеш закрепленный в QR-коде */
  changedHashValue: Scalars['String']['output'];
  /**  Наименование файла */
  fileName: Scalars['String']['output'];
  /**  Айди таски, к которому относится документ */
  taskId: Scalars['String']['output'];
}

export interface ProductContractProjection {
  __typename?: 'ProductContractProjection';
  productContractPolicyId: Scalars['UUID']['output'];
  productName: ProductEnum;
}

/**  Продукты доступные в OptimaBusiness */
export enum ProductEnum {
  /**  Оптима касса */
  OptimaKassa = 'OPTIMA_KASSA',
  /**  Зарплатный проект */
  SalaryProject = 'SALARY_PROJECT',
  /**  Рассрочка */
  TezLoans = 'TEZ_LOANS'
}

export interface ProductProjection {
  __typename?: 'ProductProjection';
  productName: ProductEnum;
  productRolePolicyId: Scalars['UUID']['output'];
  roles: ProductRoleEnum;
}

/**  Роли продуктов в OptimaBusiness (роль жёстко связана с конкретным продуктом), формат описания ролей Продукт - Роль */
export enum ProductRoleEnum {
  /**  Рассрочки - администратор, может создавать пользователей рассрочек */
  LoanManager = 'LOAN_MANAGER',
  /**  Зарплатный проект - пользователь */
  SalaryUser = 'SALARY_USER',
  /**  Рассрочки - пользователь */
  Seller = 'SELLER'
}

export interface ProductRoleType {
  __typename?: 'ProductRoleType';
  businessUserContractId: Scalars['UUID']['output'];
  productRoleEnumList: Array<ProductRoleEnum>;
}

export interface Query {
  __typename?: 'Query';
  /**  Получение метаданных api-ключа */
  apiKey: ApiKey;
  bruteForceTypes: Array<Maybe<BruteForcePolicyType>>;
  /** @deprecated Заменил на getCommonTasks() */
  changeSignRightTasks: Array<Maybe<SignRightChangesTask>>;
  commonTasks: Maybe<Array<Maybe<CommonTask>>>;
  /**  Метод для получения задач по страницам */
  commonTasksPageable: Maybe<PageOnCommonTask>;
  /**  Метод для получения информации о задачах пользователя */
  commonTasksPageableFilter: LoanEmployeeState;
  contract: Contract;
  /**  Метод получения задач создания пользователя, и првязки его к кассам, по ссылке на верификации */
  createCashierByLinkTaskPageable: PageOnCreateCashierByLinkTask;
  employee: Employee;
  /**  Получение профиля OB текущего пользователя (клиентский метод) */
  employeeSecure: Employee;
  /**  Получение сотрудников компании */
  employeesContract: Array<EmployeeContract>;
  /**  Экспорт ключа PC */
  exportPayControlKey: PayControlExportKeyResponse;
  /**
   * Метод для получения задач с пагинацией
   * Указывать соответствующий тип задач, если надо получать задачи по ТТ.
   */
  getCommonTasksByFilterPageable: Maybe<PageOnCommonTask>;
  /**  Метод для поиска контракта по совпадению наименовании компании или инн */
  getContractsByInnOrCompanyName: PageUserContractType;
  /**  Получение файла по айди таски */
  getFilesByTaskId: Array<FileData>;
  /**  Метод для поиска компании в Тундук */
  getLegalPersonInfo: Maybe<TundukLegalPersonInfoType>;
  /**  Метод для получения задачи по ID */
  getTaskById: Maybe<CommonTask>;
  /**  Получение списка настроек ограничений задач */
  getTaskConstraints: Array<TaskConstraint>;
  /**  Получение списка настроек задач */
  getTaskSettings: Array<TaskSettings>;
  /**  Метод для проверки есть ли такая активная компания по инн */
  hasActiveContractByInn: Scalars['Boolean']['output'];
  /**  Метод для получения информации, есть ли задача на верификации по типу у организации */
  hasTasksOnVerification: Scalars['Boolean']['output'];
  /**  Получение данных физ лица из карточки клиента */
  individualPerson: Maybe<IndividualPerson>;
  keyAvailability: PayControlKeyAvailability;
  /**
   * Возвращает JSON-схемы markdown-шаблонов для задачи на подписи.
   * Ошибки GraphQL:
   * IllegalStateException - задача не в ON_SIGNATURE, либо у договора нет организации или типа подписи
   * IllegalArgumentException - тип задачи не поддерживает подпись
   * SigningStartupException - неподдерживаемый тип подписи или для задачи нет схем шаблона
   * BusinessUserContractsException - для POS не найден контракт пользователя
   * ContractException - для зарплатной задачи не найден договор
   */
  markdownTemplateSchemas: Array<Scalars['String']['output']>;
  onVerificationContracts: PageOnVerificationContracts;
  onVerificationEmployees: PageOnVerificationEmployees;
  /**  Возвращает список задач на верификации для указанного пользователя в компании */
  onVerificationTaskChangesMarkers: Array<Maybe<TaskChangesMarker>>;
  /**  Список активных ключей */
  payControlActiveKeys: Array<Maybe<PcDetails>>;
  payControlKey: PayControlKey;
  /** Получение инфо о компании где зарегистрирован POS */
  posContract: Contract;
  /**  Получение профиля ПОС-терминала */
  posTerminal: PosTerminal;
  /**  Получение списка файлов, которые требуется обновить в рамках пост проверки документов юр лица */
  postVerificationWrongDocTypes: Array<FileCodeType>;
  /**
   * Обработка списка PDF файлов в base64.
   * Для получения данный из QR-кода в файле
   */
  processFiles: Array<ProcessedFileResponse>;
  ruTokenCerts: RuTokenCertType;
  taskHistory: Array<Maybe<TaskHistory>>;
  tokenId: Scalars['String']['output'];
  tokensActivity: Scalars['Boolean']['output'];
  /**  Метод для получения задач соответсвующий контракту пользователя */
  userCommonTasksPageable: Maybe<PageOnCommonTask>;
  userContractAttributes: UserContractAttributes;
  /**  Типизированное получение задач на ПОС терминалы */
  userPOSApplicationTask: PosApplicationTaskType;
  /**  Типизированное получение списка задач текущего пользователя */
  userPOSApplicationTasksPageable: Maybe<PageOnPosApplicationTask>;
  userRoles: Array<ProductRoleType>;
  userTokens: Array<Maybe<EnrollmentToken>>;
}


export interface QueryApiKeyArgs {
  orgReferenceId: Scalars['Long']['input'];
}


export interface QueryBruteForceTypesArgs {
  blockType: BlockType;
}


export interface QueryChangeSignRightTasksArgs {
  ignoreDepartment: InputMaybe<Scalars['Boolean']['input']>;
  taskState: TaskStates;
}


export interface QueryCommonTasksArgs {
  taskState: TaskStates;
  taskType: InputMaybe<TaskType>;
  transitId: InputMaybe<Array<Scalars['UUID']['input']>>;
}


export interface QueryCommonTasksPageableArgs {
  extendedFilters: InputMaybe<TaskExtendedFilters>;
  pageableDecorator: InputPageable;
  taskState: TaskStates;
}


export interface QueryCommonTasksPageableFilterArgs {
  individualInn: InputMaybe<Scalars['String']['input']>;
  orgReferenceId: Scalars['Long']['input'];
  pageableDecorator: InputPageable;
  taskState: TaskStates;
  taskType: InputMaybe<Array<InputMaybe<TaskType>>>;
}


export interface QueryContractArgs {
  orgReferenceId: Scalars['Long']['input'];
}


export interface QueryCreateCashierByLinkTaskPageableArgs {
  contractId: Scalars['UUID']['input'];
  pageableDecorator: InputPageable;
  taskStates: Array<TaskStates>;
}


export interface QueryEmployeeArgs {
  userReferenceId: Scalars['Long']['input'];
}


export interface QueryEmployeesContractArgs {
  orgReferenceId: Scalars['Long']['input'];
  userContractState: InputMaybe<UserContractState>;
}


export interface QueryExportPayControlKeyArgs {
  keyEncryptionPassword: Scalars['String']['input'];
  orgReferenceId: Scalars['Long']['input'];
}


export interface QueryGetCommonTasksByFilterPageableArgs {
  companyName: InputMaybe<Scalars['String']['input']>;
  orgReferenceId: InputMaybe<Scalars['Long']['input']>;
  pageableDecorator: InputPageable;
  taskGroup: TaskGroup;
  taskState: TaskStates;
}


export interface QueryGetContractsByInnOrCompanyNameArgs {
  orgReferenceId: Scalars['Long']['input'];
  pageableDecorator: InputPageable;
  value: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetFilesByTaskIdArgs {
  taskId: Scalars['UUID']['input'];
}


export interface QueryGetLegalPersonInfoArgs {
  orgReferenceId: Scalars['Long']['input'];
  reqBody: TundukLegalPersonInfoInput;
}


export interface QueryGetTaskByIdArgs {
  taskId: InputMaybe<Scalars['UUID']['input']>;
}


export interface QueryHasActiveContractByInnArgs {
  inn: Scalars['String']['input'];
  orgReferenceId: Scalars['Long']['input'];
}


export interface QueryHasTasksOnVerificationArgs {
  orgReferenceId: InputMaybe<Scalars['Long']['input']>;
  taskTypes: Array<TaskType>;
}


export interface QueryIndividualPersonArgs {
  inn: Scalars['String']['input'];
}


export interface QueryKeyAvailabilityArgs {
  orgReferenceId: Scalars['Long']['input'];
}


export interface QueryMarkdownTemplateSchemasArgs {
  taskId: Scalars['UUID']['input'];
}


export interface QueryOnVerificationContractsArgs {
  companyName: Scalars['String']['input'];
  contractStates: Array<ContractState>;
  pageable: InputPageable;
}


export interface QueryOnVerificationEmployeesArgs {
  companyName: Scalars['String']['input'];
  pageable: InputPageable;
  registrationStates: Array<RegistrationStates>;
}


export interface QueryOnVerificationTaskChangesMarkersArgs {
  businessUserContractIds: Array<Scalars['UUID']['input']>;
}


export interface QueryPayControlKeyArgs {
  orgReferenceId: Scalars['Long']['input'];
}


export interface QueryPostVerificationWrongDocTypesArgs {
  referenceId: Scalars['Long']['input'];
}


export interface QueryProcessFilesArgs {
  processFiles: Array<ProcessFileInput>;
}


export interface QueryRuTokenCertsArgs {
  businessUserContractId: Scalars['UUID']['input'];
}


export interface QueryTaskHistoryArgs {
  taskId: Scalars['UUID']['input'];
}


export interface QueryTokensActivityArgs {
  userReferenceId: InputMaybe<Scalars['Long']['input']>;
}


export interface QueryUserCommonTasksPageableArgs {
  businessUserContractId: Scalars['UUID']['input'];
  filters: UserCommonTaskFilters;
  pageableDecorator: InputPageable;
}


export interface QueryUserContractAttributesArgs {
  orgReferenceId: Scalars['Long']['input'];
  userReferenceId: Scalars['Long']['input'];
}


export interface QueryUserPosApplicationTaskArgs {
  businessUserContractId: Scalars['UUID']['input'];
  taskId: Scalars['UUID']['input'];
}


export interface QueryUserPosApplicationTasksPageableArgs {
  businessUserContractId: Scalars['UUID']['input'];
  pageableDecorator: InputPageable;
  taskStates: Array<TaskStates>;
  taskTypes: Array<TaskType>;
}


export interface QueryUserRolesArgs {
  businessUserContractId: InputMaybe<Array<Scalars['UUID']['input']>>;
}


export interface QueryUserTokensArgs {
  userReferenceId: Scalars['Long']['input'];
}

export enum RegistrationStates {
  /**  APPROVED */
  Approved = 'APPROVED',
  /**  DECLINED */
  Declined = 'DECLINED',
  /**  DRAFT */
  Draft = 'DRAFT',
  /**  ON_MERCHANT_VERIFICATION */
  OnMerchantVerification = 'ON_MERCHANT_VERIFICATION',
  /**  ON_VERIFICATION */
  OnVerification = 'ON_VERIFICATION',
  /**  VERDICT_CHOICE */
  VerdictChoice = 'VERDICT_CHOICE',
  /**  VERDICT_ERROR */
  VerdictError = 'VERDICT_ERROR'
}

export interface RuTokenCertType {
  __typename?: 'RuTokenCertType';
  certId: Scalars['String']['output'];
  id: Scalars['Long']['output'];
}

export interface SalePointAccessDetails {
  __typename?: 'SalePointAccessDetails';
  cashDetails: Array<CashAccessDetails>;
  salePointId: Scalars['Long']['output'];
  salePointName: Maybe<Scalars['String']['output']>;
}

export interface SalePointAttributeInput {
  city: InputMaybe<Scalars['String']['input']>;
  district: InputMaybe<Scalars['String']['input']>;
  houseNumber: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Array<Scalars['String']['input']>>;
  region: InputMaybe<Scalars['String']['input']>;
  street: InputMaybe<Scalars['String']['input']>;
}

export interface SalePointTaskInput {
  account: InputMaybe<Scalars['String']['input']>;
  /**  Аттрибуты ТТ с адресами */
  attribute: InputMaybe<SalePointAttributeInput>;
  checkName: InputMaybe<Scalars['String']['input']>;
  code: Scalars['Long']['input'];
  id: Scalars['Long']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  orgReferenceId: Scalars['Long']['input'];
  /**  Аттрибуты ТТ с налоговыми данными */
  taxAttribute: InputMaybe<SalePointTaxAttributeInput>;
}

export interface SalePointTaxAttributeInput {
  /**  Координаты которые не должны выходить за пределы КР */
  coordinates: InputMaybe<Scalars['String']['input']>;
  /**  Почтовый индекс */
  postalCode: InputMaybe<Scalars['String']['input']>;
  /**  Налоговая служба */
  taxService: InputMaybe<Scalars['String']['input']>;
}

export interface ShoppingCentreInfoInput {
  boutiqueName: InputMaybe<Scalars['String']['input']>;
  floor: InputMaybe<Scalars['String']['input']>;
  shoppingCentreName: InputMaybe<Scalars['String']['input']>;
}

export interface ShortUser {
  __typename?: 'ShortUser';
  fullName: Scalars['String']['output'];
  signRight: SignRight;
}

export enum SignRight {
  /**  User without any right to create or sign any operation, read only */
  Auditor = 'AUDITOR',
  /**  User has access to cash functions only, can't sign or use accounts */
  Cashier = 'CASHIER',
  /**  User has access to sale points functions and manage it, cash functions included */
  CashManager = 'CASH_MANAGER',
  /**  May create operation, but can't sign it */
  Creator = 'CREATOR',
  /**  May create and sign operation (first signer) */
  First = 'FIRST',
  /**  Client can`t do anything */
  None = 'NONE',
  /**  May create and sign operation */
  Second = 'SECOND',
  /**  May create and sign operation */
  Third = 'THIRD'
}

export interface SignRightChangesTask {
  __typename?: 'SignRightChangesTask';
  companyName: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['LocalDateTime']['output'];
  id: Scalars['UUID']['output'];
  newValue: SignRight;
  oldValue: SignRight;
  reason: Scalars['String']['output'];
  taskState: TaskStates;
  transitId: Scalars['UUID']['output'];
  type: TaskType;
  updatedDate: Scalars['LocalDateTime']['output'];
  userName: Maybe<Scalars['String']['output']>;
}

export enum SignScheme {
  /**  ONE_SIGNATORY */
  OneSignatory = 'ONE_SIGNATORY',
  /**  THREE_SIGNATORY */
  ThreeSignatory = 'THREE_SIGNATORY',
  /**  TWO_SIGNATORY */
  TwoSignatory = 'TWO_SIGNATORY'
}

export enum SignType {
  /**  PAY_CONTROL */
  PayControl = 'PAY_CONTROL',
  /**  RU_TOKEN_2 */
  RuToken_2 = 'RU_TOKEN_2',
  /**  RU_TOKEN_S */
  RuTokenS = 'RU_TOKEN_S',
  /**  TOTP */
  Totp = 'TOTP'
}

export interface Subscription {
  __typename?: 'Subscription';
  taskSignatureResult: TaskSignatureSubscriptionResult;
  taskUpdates: TaskUpdates;
}


export interface SubscriptionTaskSignatureResultArgs {
  taskId: Scalars['UUID']['input'];
}


export interface SubscriptionTaskUpdatesArgs {
  ids: Array<Scalars['UUID']['input']>;
  orgReferenceId: Scalars['Long']['input'];
}

export interface TaskChangesMarker {
  __typename?: 'TaskChangesMarker';
  /**  ID пользователя в компании */
  businessUserContractId: Scalars['UUID']['output'];
  /**  Данные изменений, затронутых данной задачей */
  changedAttributes: Array<Maybe<Scalars['String']['output']>>;
  /**  Тип задачи */
  taskType: TaskType;
}

export interface TaskConstraint {
  __typename?: 'TaskConstraint';
  affectedAttributes: Maybe<Array<Scalars['String']['output']>>;
  affectedRoles: Maybe<Array<Scalars['String']['output']>>;
  duration: Scalars['Duration']['output'];
  hookOnState: Maybe<TaskStates>;
  id: Scalars['UUID']['output'];
  maxPerDay: Scalars['Int']['output'];
  priority: Maybe<Scalars['Short']['output']>;
  taskType: TaskType;
  taskTypeId: Scalars['UUID']['output'];
}

export interface TaskConstraintInput {
  /**  Параметр для проверки ограничений при изменении атрибута задачи */
  affectedAttributes: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Параметр для проверки ограничений для определенных ролей пользователей */
  affectedRoles: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Длительность ограничения относительно времени создания задач указанного типа,
   * формат: <number><s|m|h|d>, напр. - 30s, s - секунды, m - минуты, h - часы, d - дни.
   * Можно передать только число, в таком случае значение будет интерпретироваться как секунды
   * с переводом в формат s|m|h|d.
   */
  duration: Scalars['Duration']['input'];
  hookOnState: InputMaybe<TaskStates>;
  /**  Для обновления требуется передавать id, в противном случае будет создано новое ограничение */
  id: InputMaybe<Scalars['UUID']['input']>;
  /**  Ограничение на количество создаваемых задач в день */
  maxPerDay: Scalars['Int']['input'];
  /**  Приоритет выполнения ограничений, по умолчанию огранчиение не учитывается */
  priority: InputMaybe<Scalars['Short']['input']>;
  /**  Id настройки, неизменяемое поле, */
  taskTypeId: Scalars['UUID']['input'];
}

export interface TaskDocument {
  /**  Файл в формате base64 */
  base64: Scalars['String']['input'];
  /**  Необязательный параметр для хеша измененных данных для ККМ */
  changedHash: InputMaybe<Scalars['String']['input']>;
  /**  Наименование файла */
  fileName: Scalars['String']['input'];
}

export interface TaskExtendedFilters {
  /**
   * Фильтр задач по наименованию компании, (!) фильтр НЕ применится если задача была создана
   * с привязкой к любой другой сущности кроме компании (contract)
   */
  companyName: InputMaybe<Scalars['String']['input']>;
  /**  При указании данного id, будут возвращены только дочерние подзадачи из этой группы */
  groupId: InputMaybe<Scalars['UUID']['input']>;
  /**  Вывод задач без учета подразделения, по умолчанию подразделение учитывается */
  ignoreDepartment: InputMaybe<Scalars['Boolean']['input']>;
  /** Универсальный фильтр по new_value (jsonb), аналогично с полем oldValueJsonContains */
  newValueJsonContains: InputMaybe<Scalars['String']['input']>;
  /**
   * Универсальный фильтр по old_value в заявках, заявка должна хранить в себе переданный фрагмент JSON.
   * Пример {"createCash":{"salePointId":11}}; {"ccrId:155"}. В зависимости от типа задачи JSON фрагменты
   * могут структурно отличаться
   */
  oldValueJsonContains: InputMaybe<Scalars['String']['input']>;
  /** Разделяет вывод задач по группам, относящихся к разным доменным областям */
  taskGroup: TaskGroup;
  /** Разделение по типам задач. Если не null - приоритет выше чем taskGroup */
  taskTypes: InputMaybe<Array<TaskType>>;
}

export enum TaskGroup {
  /**  Задачи по сущностям модуля ККМ */
  ObCcr = 'OB_CCR',
  /**  Задачи по сущностям торговых точек */
  ObSalePoint = 'OB_SALE_POINT',
  /**  Задачи по учетным записям пользователей (компании, атрибуты пользователей и т.д.) */
  ObUserAccount = 'OB_USER_ACCOUNT'
}

export interface TaskHistory {
  __typename?: 'TaskHistory';
  companyName: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  id: Scalars['UUID']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  taskState: TaskStates;
  transitId: Scalars['UUID']['output'];
  type: TaskType;
  updatedBy: Scalars['String']['output'];
  updatedDate: Scalars['LocalDateTime']['output'];
  userName: Maybe<Scalars['String']['output']>;
}

export interface TaskSettings {
  __typename?: 'TaskSettings';
  id: Scalars['UUID']['output'];
  taskType: Scalars['String']['output'];
}

export interface TaskSignatureSubscriptionResult {
  __typename?: 'TaskSignatureSubscriptionResult';
  taskId: Scalars['UUID']['output'];
  taskState: TaskStates;
}

export interface TaskSigningPayload {
  __typename?: 'TaskSigningPayload';
  markdownTemplates: Array<Scalars['String']['output']>;
  markdowns: Array<Scalars['String']['output']>;
}

export enum TaskStates {
  /**  Фильтр по всем состояниям, не используется при создании задач */
  All = 'ALL',
  /**  Задача одобрена и выполнена */
  Approved = 'APPROVED',
  /**  Задача отклонена, изменения не были применены */
  Declined = 'DECLINED',
  /**  Обратимая техническая ошибка при выполнении задачи, необходимо повторное исполнение пользователем или системой */
  ExecutionError = 'EXECUTION_ERROR',
  /** В процессе */
  InProgress = 'IN_PROGRESS',
  /**  На корректировке */
  OnAdjustment = 'ON_ADJUSTMENT',
  /**  На подписи, ожидаются решения подписантов */
  OnSignature = 'ON_SIGNATURE',
  /**  На верификации, задача требует контроля */
  OnVerification = 'ON_VERIFICATION',
  /**  Техническая ошибка при контроле, необходимо повторно создать задачу */
  VerdictError = 'VERDICT_ERROR'
}

/**  Виды задач, определяют действия совершённые пользователями */
export enum TaskType {
  /**  Добавление ролей администратор, продавец рассрочек */
  AddLoansProductRolesToUser = 'ADD_LOANS_PRODUCT_ROLES_TO_USER',
  /**  Добавление роли продавец рассрочек лица другого клиента */
  AddSellerRoleToUser = 'ADD_SELLER_ROLE_TO_USER',
  /**
   *  FIXME !!!! удалить !!!!
   *  Фильтр по всем задачам, не использовать при создании задачи
   */
  All = 'ALL',
  /**  Изменение контактов */
  ChangeContacts = 'CHANGE_CONTACTS',
  /**  Изменение контактов от лица клиента */
  ChangeContactsFromUser = 'CHANGE_CONTACTS_FROM_USER',
  /**  Изменение каналов связи договора */
  ChangeContractCommunicationChannels = 'CHANGE_CONTRACT_COMMUNICATION_CHANNELS',
  /**  Изменение филиала обслуживания клиента */
  ChangeDepartment = 'CHANGE_DEPARTMENT',
  /**  Изменение списка сотрудников зарплатного проекта */
  ChangeEmployeesInSalaryContractTask = 'CHANGE_EMPLOYEES_IN_SALARY_CONTRACT_TASK',
  /**  Изменение способа идентификации клиента */
  ChangeIdentificationType = 'CHANGE_IDENTIFICATION_TYPE',
  /**  Изменение сертификата ru_token */
  ChangeRuTokenCerts = 'CHANGE_RU_TOKEN_CERTS',
  /**  Изменение права подписи (роли) */
  ChangeSignRight = 'CHANGE_SIGN_RIGHT',
  /**  Изменение типа подписи */
  ChangeSignType = 'CHANGE_SIGN_TYPE',
  /**  Изменение активности пользователя */
  ChangeUserActivity = 'CHANGE_USER_ACTIVITY',
  /**  Увольнение/восстановление сотрудника в компании */
  ChangeUserActivityInCompany = 'CHANGE_USER_ACTIVITY_IN_COMPANY',
  /**  Изменение роли продавца/администратора рассрочки */
  ChangeUserRoles = 'CHANGE_USER_ROLES',
  /**  Создание business-user`a с ролью продавец со стороны управляющего рассрочкой/клиента */
  CreateBuSellerFromUser = 'CREATE_BU_SELLER_FROM_USER',
  /**  Создание кассира по реферальной ссылке */
  CreateCashierByLinkTask = 'CREATE_CASHIER_BY_LINK_TASK',
  /**  Добавление нового сертификата ru_token */
  CreateRuTokenCerts = 'CREATE_RU_TOKEN_CERTS',
  /**  СОЗДАНИЕ КАССЫ ДЛЯ ТТ */
  CreatingCashTask = 'CREATING_CASH_TASK',
  /**  Создание новой ККМ */
  CreatingCcrTask = 'CREATING_CCR_TASK',
  /**  Создание торговой точки */
  CreatingSalePointTask = 'CREATING_SALE_POINT_TASK',
  /**  Изменения данных физ.лица */
  DataSynchronizationIndividual = 'DATA_SYNCHRONIZATION_INDIVIDUAL',
  /**  Изменения данных юр.лица */
  DataSynchronizationLegal = 'DATA_SYNCHRONIZATION_LEGAL',
  /**  Удаление учетной записи ПККМ-POS */
  DeletePkkmPosAccountTask = 'DELETE_PKKM_POS_ACCOUNT_TASK',
  /**  Удаление сертификата ru_token */
  DeleteRuTokenCerts = 'DELETE_RU_TOKEN_CERTS',
  /**  Тип задачи, заявка при которой ККМ идет на снятие с учета. */
  DeregisterCcrTask = 'DEREGISTER_CCR_TASK',
  /**  РЕДАКТИРОВАНИЕ КАССЫ ДЛЯ ТТ */
  EditingCashTask = 'EDITING_CASH_TASK',
  /**
   * Редактирование ККМ, подзадача. Может подлежать релоуду -> метод verdictForGroupTask, указывать
   * id данной задачи для релоада, если статус будет EXECUTION_ERROR.
   */
  EditingCcrTask = 'EDITING_CCR_TASK',
  /**  Тип задачи редактирование дефолтной ставки */
  EditingDefaultTaxRateTask = 'EDITING_DEFAULT_TAX_RATE_TASK',
  /**  Редактирование профиля организации в ЦТО, подзадача. */
  EditingOrgProfileCcrTask = 'EDITING_ORG_PROFILE_CCR_TASK',
  /**  Редактирование торговой точки в ЦТО, подзадача. */
  EditingSalePointCcrTask = 'EDITING_SALE_POINT_CCR_TASK',
  /**  Создание торговой точки */
  EditingSalePointTask = 'EDITING_SALE_POINT_TASK',
  /** Изменение налогового профиля организации */
  EditingTaxProfileOfOrg = 'EDITING_TAX_PROFILE_OF_ORG',
  /**
   * Редактирование данных торговой точки, налогоплательщика и ККМ
   * Основной тип родительской задачи. Все остальные с таким GroupId -> дочерние
   */
  MassEditingCcrTask = 'MASS_EDITING_CCR_TASK',
  /**  Заявка на POS-терминал */
  PosTerminalApplication = 'POS_TERMINAL_APPLICATION',
  /**  Удаление роли администратора рассрочки со стороны EFR */
  RemoveLoansRole = 'REMOVE_LOANS_ROLE',
  /**  Удаление роли продавца рассрочек */
  RemoveSellerRoleFromUser = 'REMOVE_SELLER_ROLE_FROM_USER',
  /**  Обновление пароля от лица клиента */
  RenewPassword = 'RENEW_PASSWORD',
  /**  Установка нового пароля и его отправка по установленным каналам связи (напр. sms) */
  RenewPasswordAndSend = 'RENEW_PASSWORD_AND_SEND',
  /**  Управление доступом к продуктам */
  SwitchProductAccess = 'SWITCH_PRODUCT_ACCESS',
  /**  Изменение доступа организации к продуктам банка */
  SwitchProductAccessOptimaKassaTask = 'SWITCH_PRODUCT_ACCESS_OPTIMA_KASSA_TASK',
  TestTask = 'TEST_TASK',
  /**  Включает возможности 2го фактора аутентификации, в случае их блокировки по брутфорс политикам */
  Unlock_2Fa = 'UNLOCK_2FA',
  /**  Изменение сертификата ru_token от лица клиента */
  UserChangeRuTokenCerts = 'USER_CHANGE_RU_TOKEN_CERTS',
  /**  Добавление нового сертификата ru_token от лица клиента */
  UserCreateRuTokenCerts = 'USER_CREATE_RU_TOKEN_CERTS'
}

export interface TaskUpdates {
  __typename?: 'TaskUpdates';
  id: Scalars['UUID']['output'];
  newValue: Scalars['String']['output'];
  taskState: TaskStates;
}

export interface TaxSystemsInput {
  /**  Плательщик НДС  */
  isVatPayer: Scalars['Boolean']['input'];
  /**  Налоговый режим  */
  taxSystemCode: Scalars['Short']['input'];
}

export enum TokenType {
  /**  email */
  Email = 'email',
  /**  sms */
  Sms = 'sms',
  /**  totp */
  Totp = 'totp'
}

export interface TundukLegalPersonBodyResponseType {
  __typename?: 'TundukLegalPersonBodyResponseType';
  /**  Список обьектов о компании */
  content: Maybe<Array<Maybe<TundukLegalPersonContentType>>>;
  /**  Информации о пагинации */
  pageableData: Maybe<TundukLegalPersonPageableData>;
}

export interface TundukLegalPersonContentType {
  __typename?: 'TundukLegalPersonContentType';
  /**  Наименование компании */
  fullName: Maybe<Scalars['String']['output']>;
  /**  Идентификатор компании */
  id: Maybe<Scalars['String']['output']>;
  /**  Инн компании */
  inn: Maybe<Scalars['String']['output']>;
  /**  Признак резидентства */
  isResident: Maybe<Scalars['Boolean']['output']>;
}

export interface TundukLegalPersonInfoInput {
  /**  ФИО(наименование компании), в случае отсутствие передать пустую строку */
  fullName: Scalars['String']['input'];
  /**  Признак резидентства */
  isResident: Scalars['String']['input'];
  /**  Размер страницы */
  size: Scalars['String']['input'];
  /**  Инн компании без пробелов, в случае отсутствие передать пустую строку */
  tin: Scalars['String']['input'];
}

export interface TundukLegalPersonInfoType {
  __typename?: 'TundukLegalPersonInfoType';
  /**  Обьект с полезной информацией */
  bodyResponse: Maybe<TundukLegalPersonBodyResponseType>;
  /**  Описание кода результата */
  codeDescription: Maybe<Scalars['String']['output']>;
  /**  Код результата */
  codeResult: Maybe<Scalars['String']['output']>;
  /**  уникальный идентификатор запроса */
  traceId: Maybe<Scalars['UUID']['output']>;
}

export interface TundukLegalPersonPageableData {
  __typename?: 'TundukLegalPersonPageableData';
  pageNumber: Maybe<Scalars['Int']['output']>;
  pageSize: Maybe<Scalars['Int']['output']>;
  totalElements: Maybe<Scalars['Long']['output']>;
  totalPages: Maybe<Scalars['Long']['output']>;
}

/**  Объект для настройки ККМ  */
export interface UpdateCcrSettings {
  /**  Код вида деятельности ККМ (danger)  */
  businessActivityCode: InputMaybe<Scalars['Int']['input']>;
  /**  Предмет расчёта  */
  calcItemAttributeCodes: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**  Id ККМ  */
  ccrId: Scalars['Long']['input'];
  /**  Айди ТТ в которой сейчас находится ККМ  */
  currentSalePointId: Scalars['Long']['input'];
  /**  При снятии с учета кассы, можно указать причину снятии с учета ККМ  */
  deregisterReason: InputMaybe<Scalars['String']['input']>;
  /**  Объект предпринимательства (danger)  */
  entrepreneurshipObjectCode: InputMaybe<Scalars['Int']['input']>;
  /**  Если ККМ идет на снятие с учета. По умолчанию false, true -> если ККМ на снятие с учета */
  forDeregister: InputMaybe<Scalars['Boolean']['input']>;
  /**  ID организации, референс юр лица  */
  orgReferenceId: Scalars['Long']['input'];
  /**
   * Список причин перерегистрации
   * 0 - Изменение адреса и места установки ККМ
   * 1 - Изменение параметров налогооблажения
   * 2 - Изменение реквизитов пользователя ККМ
   * 3 - Изменение версии модели ККТ
   */
  reasonCodes: Array<Scalars['Int']['input']>;
  /**  Указывать айди торговой точки если - у ККМ изменение на новую ТТ  */
  targetSalePointId: InputMaybe<Scalars['Long']['input']>;
}

export interface UpdateFiles {
  base64Data: Scalars['Base64']['input'];
  originalFileName: Scalars['String']['input'];
  typeCode: FileCodeType;
}

export interface User {
  __typename?: 'User';
  contractId: Scalars['UUID']['output'];
  fullName: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
}

export interface UserCommonTaskFilters {
  /** Универсальный фильтр по new_value (jsonb), аналогично с полем oldValueJsonContains */
  newValueJsonContains: InputMaybe<Scalars['String']['input']>;
  /**
   * Универсальный фильтр по old_value в заявках, заявка должна хранить в себе переданный фрагмент JSON.
   * Пример {"createCash":{"salePointId":11}}; {"ccrId:155"}. В зависимости от типа задачи JSON фрагменты
   * могут структурно отличаться
   */
  oldValueJsonContains: InputMaybe<Scalars['String']['input']>;
  taskGroup: InputMaybe<TaskGroup>;
  taskState: TaskStates;
  taskTypes: InputMaybe<Array<TaskType>>;
}

export interface UserContractActivityToChange {
  __typename?: 'UserContractActivityToChange';
  state: UserContractState;
  /**  Id отношений business user и contract (см. UserContractAttributes) */
  userContractId: Scalars['UUID']['output'];
}

export interface UserContractAttributes {
  __typename?: 'UserContractAttributes';
  createdDate: Scalars['LocalDateTime']['output'];
  productRoles: Array<ProductProjection>;
  registrationState: RegistrationStates;
  signRight: SignRight;
  userContractId: Scalars['UUID']['output'];
  userContractState: UserContractState;
}

export enum UserContractState {
  /**  Пользователь активен в компании */
  Active = 'ACTIVE',
  /**  Тех состояние фильтра для возврата всех состояний */
  All = 'ALL',
  /**  Пользователь не имеет доступа к компании (уволен) */
  Freeze = 'FREEZE'
}

export enum VerificationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type UserContractAttributesFragment = { __typename?: 'UserContractAttributes', signRight: SignRight, registrationState: RegistrationStates, userContractState: UserContractState, userContractId: string, productRoles: Array<{ __typename?: 'ProductProjection', productName: ProductEnum, roles: ProductRoleEnum }> };

export type PayControlKeyFragment = { __typename?: 'PayControlKey', expirationDate: string, username: string, status: string, pcUserId: string };

export type ShortUserFragment = { __typename?: 'ShortUser', fullName: string, signRight: SignRight };

export type PayControlKeyAvailabilityFragment = { __typename?: 'PayControlKeyAvailability', available: boolean, orgReferenceId: number, nonAvailableFor: Array<{ __typename?: 'ShortUser', fullName: string, signRight: SignRight } | null> };

export type UserContractsFragment = { __typename?: 'Contract', id: string, inn: string, active: boolean, signType: SignType, signScheme: SignScheme, companyName: string, contractNum: string, createdDate: string, departmentCode: string, departmentName: string, expirationDate: string, orgReferenceId: number, isDigital: boolean, payControlKey: { __typename?: 'PayControlKey', expirationDate: string, username: string, status: string, pcUserId: string } | null, userContractAttributes: { __typename?: 'UserContractAttributes', signRight: SignRight, registrationState: RegistrationStates, userContractState: UserContractState, userContractId: string, productRoles: Array<{ __typename?: 'ProductProjection', productName: ProductEnum, roles: ProductRoleEnum }> } | null };

export type EmployeeFragment = { __typename?: 'Employee', id: string, email: string | null, mobile: string, fullName: string, shortName: string, createdDate: string, individualInn: string, userReferenceId: number, postVerificationStatus: VerificationStatus, userContracts: Array<{ __typename?: 'Contract', id: string, inn: string, active: boolean, signType: SignType, signScheme: SignScheme, companyName: string, contractNum: string, createdDate: string, departmentCode: string, departmentName: string, expirationDate: string, orgReferenceId: number, isDigital: boolean, payControlKey: { __typename?: 'PayControlKey', expirationDate: string, username: string, status: string, pcUserId: string } | null, userContractAttributes: { __typename?: 'UserContractAttributes', signRight: SignRight, registrationState: RegistrationStates, userContractState: UserContractState, userContractId: string, productRoles: Array<{ __typename?: 'ProductProjection', productName: ProductEnum, roles: ProductRoleEnum }> } | null }> };

export type EmployeeContractFragment = { __typename?: 'EmployeeContract', id: string, email: string | null, mobile: string, fullName: string, shortName: string, signRight: SignRight, createdDate: string, referenceId: number, individualInn: string, registrationState: RegistrationStates, userContractState: UserContractState };

export type PayControlCreateKeyFragment = { __typename?: 'PayControlCreateKey', qr: string, key: string | null, status: string, username: string, pcUserId: string, expirationDate: string };

export type LoanEmployeeFragment = { __typename?: 'LoanEmployeeState', totalPages: number, list: Array<{ __typename?: 'OnLoanEmployeeState', fullName: string | null, reason: string, referenceId: number | null, taskState: TaskStates, individualInn: string | null, createdDate: string, locationId: number }> };

export type PosApplicationTypeFragment = { __typename?: 'POSApplicationType', legalAddress: string | null, actualAddress: string | null, mainActivity: string | null, storeName: string | null, storeAddress: string | null, accountType: AccountType | null, clientAccount: string | null, offerTypes: string | null, clientContactName: string | null, clientContactAddress: string | null, clientContactNumber: string | null, hasSecurity: boolean | null, terminalsCount: any | null, hasClientKkm: boolean | null, workingDays: string | null, bdoState: BdoState | null, rejectReason: string | null };

export type PosApplicationTaskBriefFragment = { __typename?: 'POSApplicationTaskType', id: string, createdDate: string, newValue: { __typename?: 'POSApplicationType', storeName: string | null, terminalsCount: any | null, bdoState: BdoState | null } };

export type PosApplicationTaskFragment = { __typename?: 'POSApplicationTaskType', id: string, createdDate: string, newValue: { __typename?: 'POSApplicationType', legalAddress: string | null, actualAddress: string | null, mainActivity: string | null, storeName: string | null, storeAddress: string | null, accountType: AccountType | null, clientAccount: string | null, offerTypes: string | null, clientContactName: string | null, clientContactAddress: string | null, clientContactNumber: string | null, hasSecurity: boolean | null, terminalsCount: any | null, hasClientKkm: boolean | null, workingDays: string | null, bdoState: BdoState | null, rejectReason: string | null } };

export type PageOnPosTaskFragment = { __typename?: 'PageOnPOSApplicationTask', totalPages: number, totalElements: number, list: Array<{ __typename?: 'POSApplicationTaskType', id: string, createdDate: string, newValue: { __typename?: 'POSApplicationType', storeName: string | null, terminalsCount: any | null, bdoState: BdoState | null } }> };

export type CreateApiKeyFragment = { __typename?: 'CreatedApiKey', validUntil: string, key: string, apiKeyAccessList: Array<{ __typename?: 'ApiKeyAccess', api: string }> };

export type ApiKeyFragment = { __typename?: 'ApiKey', createdDate: string, validUntil: string, apiKeyAccessList: Array<{ __typename?: 'ApiKeyAccess', api: string }> };

export type PageOnCreateCashierByLinkTaskFragment = { __typename?: 'PageOnCreateCashierByLinkTask', totalPages: number, list: Array<{ __typename?: 'CreateCashiersByLinkTask', id: string, taskState: TaskStates, updatedBy: string, newValue: { __typename?: 'CreateCashierTaskDetails', phoneNumber: string, cashierFullName: string, salePoints: Array<{ __typename?: 'SalePointAccessDetails', salePointName: string | null, cashDetails: Array<{ __typename?: 'CashAccessDetails', cashCode: number | null }> }> } }> };

export type CountCreateCashierByLinkTaskFragment = { __typename?: 'PageOnCreateCashierByLinkTask', totalElements: number };

export type PageUserContractsFragment = { __typename?: 'PageUserContractType', totalElements: number, totalPages: number, list: Array<{ __typename?: 'Contract', id: string, inn: string, active: boolean, signType: SignType, signScheme: SignScheme, companyName: string, contractNum: string, createdDate: string, departmentCode: string, departmentName: string, expirationDate: string, orgReferenceId: number, isDigital: boolean, payControlKey: { __typename?: 'PayControlKey', expirationDate: string, username: string, status: string, pcUserId: string } | null, userContractAttributes: { __typename?: 'UserContractAttributes', signRight: SignRight, registrationState: RegistrationStates, userContractState: UserContractState, userContractId: string, productRoles: Array<{ __typename?: 'ProductProjection', productName: ProductEnum, roles: ProductRoleEnum }> } | null }> };

export type TundukLegalPersonContentFragment = { __typename?: 'TundukLegalPersonContentType', id: string | null, inn: string | null, fullName: string | null, isResident: boolean | null };

export type TundukLegalPersonPageableDataFragment = { __typename?: 'TundukLegalPersonPageableData', pageNumber: number | null, pageSize: number | null, totalElements: number | null, totalPages: number | null };

export type TundukLegalPersonBodyResponseFragment = { __typename?: 'TundukLegalPersonBodyResponseType', content: Array<{ __typename?: 'TundukLegalPersonContentType', id: string | null, inn: string | null, fullName: string | null, isResident: boolean | null } | null> | null, pageableData: { __typename?: 'TundukLegalPersonPageableData', pageNumber: number | null, pageSize: number | null, totalElements: number | null, totalPages: number | null } | null };

export type TundukLegalPersonInfoFragment = { __typename?: 'TundukLegalPersonInfoType', codeDescription: string | null, traceId: string | null, codeResult: string | null, bodyResponse: { __typename?: 'TundukLegalPersonBodyResponseType', content: Array<{ __typename?: 'TundukLegalPersonContentType', id: string | null, inn: string | null, fullName: string | null, isResident: boolean | null } | null> | null, pageableData: { __typename?: 'TundukLegalPersonPageableData', pageNumber: number | null, pageSize: number | null, totalElements: number | null, totalPages: number | null } | null } | null };

export type CreateBusinessUserContractWithRoleSellerTaskMutationVariables = Exact<{
  userInfo: InputUserInfoRecord;
  orgReferenceId: Scalars['Long']['input'];
}>;


export type CreateBusinessUserContractWithRoleSellerTaskMutation = { __typename?: 'Mutation', createBusinessUserContractWithRoleSellerTask: string };

export type SavePosApplicationTaskMutationVariables = Exact<{
  businessUserContractId: Scalars['UUID']['input'];
  posApplication: PosApplication;
}>;


export type SavePosApplicationTaskMutation = { __typename?: 'Mutation', POSApplicationTask: string };

export type CreateApiKeyMutationVariables = Exact<{
  orgReferenceId: Scalars['Long']['input'];
  password: Scalars['String']['input'];
  apiKeyAccessList: Array<ApiKeyAccessInput> | ApiKeyAccessInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'CreatedApiKey', validUntil: string, key: string, apiKeyAccessList: Array<{ __typename?: 'ApiKeyAccess', api: string }> } };

export type SavePayDaApplicationTaskMutationVariables = Exact<{
  businessUserContractId: Scalars['UUID']['input'];
  payDaApplication: PayDaApplicationDto;
}>;


export type SavePayDaApplicationTaskMutation = { __typename?: 'Mutation', payDaApplicationTask: string };

export type SwitchProductRolePolicyMutationVariables = Exact<{
  businessUserContractId: Scalars['UUID']['input'];
  productRole: ProductRoleEnum;
  switchAccess: Scalars['Boolean']['input'];
}>;


export type SwitchProductRolePolicyMutation = { __typename?: 'Mutation', switchProductRolePolicy: string };

export type VerdictForTaskMutationVariables = Exact<{
  taskId: Scalars['UUID']['input'];
  verdict: Scalars['Boolean']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
}>;


export type VerdictForTaskMutation = { __typename?: 'Mutation', verdictForTask: boolean };

export type CreateMarkdownMutationVariables = Exact<{
  taskId: Scalars['UUID']['input'];
  markdownTemplates: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateMarkdownMutation = { __typename?: 'Mutation', createMarkdown: { __typename?: 'TaskSigningPayload', markdowns: Array<string>, markdownTemplates: Array<string> } };

export type EmployeeSecureQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeSecureQuery = { __typename?: 'Query', employeeSecure: { __typename?: 'Employee', id: string, email: string | null, mobile: string, fullName: string, shortName: string, createdDate: string, individualInn: string, userReferenceId: number, postVerificationStatus: VerificationStatus, userContracts: Array<{ __typename?: 'Contract', id: string, inn: string, active: boolean, signType: SignType, signScheme: SignScheme, companyName: string, contractNum: string, createdDate: string, departmentCode: string, departmentName: string, expirationDate: string, orgReferenceId: number, isDigital: boolean, payControlKey: { __typename?: 'PayControlKey', expirationDate: string, username: string, status: string, pcUserId: string } | null, userContractAttributes: { __typename?: 'UserContractAttributes', signRight: SignRight, registrationState: RegistrationStates, userContractState: UserContractState, userContractId: string, productRoles: Array<{ __typename?: 'ProductProjection', productName: ProductEnum, roles: ProductRoleEnum }> } | null }> } };

export type EmployeeQueryVariables = Exact<{
  userReferenceId: Scalars['Long']['input'];
}>;


export type EmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string, email: string | null, mobile: string, fullName: string, shortName: string, createdDate: string, individualInn: string, userReferenceId: number, postVerificationStatus: VerificationStatus, userContracts: Array<{ __typename?: 'Contract', id: string, inn: string, active: boolean, signType: SignType, signScheme: SignScheme, companyName: string, contractNum: string, createdDate: string, departmentCode: string, departmentName: string, expirationDate: string, orgReferenceId: number, isDigital: boolean, payControlKey: { __typename?: 'PayControlKey', expirationDate: string, username: string, status: string, pcUserId: string } | null, userContractAttributes: { __typename?: 'UserContractAttributes', signRight: SignRight, registrationState: RegistrationStates, userContractState: UserContractState, userContractId: string, productRoles: Array<{ __typename?: 'ProductProjection', productName: ProductEnum, roles: ProductRoleEnum }> } | null }> } };

export type EmployeesContractQueryVariables = Exact<{
  orgReferenceId: Scalars['Long']['input'];
}>;


export type EmployeesContractQuery = { __typename?: 'Query', employeesContract: Array<{ __typename?: 'EmployeeContract', id: string, email: string | null, mobile: string, fullName: string, shortName: string, signRight: SignRight, createdDate: string, referenceId: number, individualInn: string, registrationState: RegistrationStates, userContractState: UserContractState }> };

export type KeyAvailabilityQueryVariables = Exact<{
  orgReferenceId: Scalars['Long']['input'];
}>;


export type KeyAvailabilityQuery = { __typename?: 'Query', keyAvailability: { __typename?: 'PayControlKeyAvailability', available: boolean, orgReferenceId: number, nonAvailableFor: Array<{ __typename?: 'ShortUser', fullName: string, signRight: SignRight } | null> } };

export type GetSellersQueryVariables = Exact<{
  taskState: TaskStates;
  pageableDecorator: InputPageable;
  individualInn: InputMaybe<Scalars['String']['input']>;
  orgReferenceId: Scalars['Long']['input'];
  taskType: InputMaybe<Array<InputMaybe<TaskType>> | InputMaybe<TaskType>>;
}>;


export type GetSellersQuery = { __typename?: 'Query', commonTasksPageableFilter: { __typename?: 'LoanEmployeeState', totalPages: number, list: Array<{ __typename?: 'OnLoanEmployeeState', fullName: string | null, reason: string, referenceId: number | null, taskState: TaskStates, individualInn: string | null, createdDate: string, locationId: number }> } };

export type UserPosApplicationTasksPageableQueryVariables = Exact<{
  businessUserContractId: Scalars['UUID']['input'];
  taskTypes: Array<TaskType> | TaskType;
  taskStates: Array<TaskStates> | TaskStates;
  pageableDecorator: InputPageable;
}>;


export type UserPosApplicationTasksPageableQuery = { __typename?: 'Query', userPOSApplicationTasksPageable: { __typename?: 'PageOnPOSApplicationTask', totalPages: number, totalElements: number, list: Array<{ __typename?: 'POSApplicationTaskType', id: string, createdDate: string, newValue: { __typename?: 'POSApplicationType', storeName: string | null, terminalsCount: any | null, bdoState: BdoState | null } }> } | null };

export type GetUserPosApplicationTaskQueryVariables = Exact<{
  taskId: Scalars['UUID']['input'];
  businessUserContractId: Scalars['UUID']['input'];
}>;


export type GetUserPosApplicationTaskQuery = { __typename?: 'Query', userPOSApplicationTask: { __typename?: 'POSApplicationTaskType', id: string, createdDate: string, newValue: { __typename?: 'POSApplicationType', legalAddress: string | null, actualAddress: string | null, mainActivity: string | null, storeName: string | null, storeAddress: string | null, accountType: AccountType | null, clientAccount: string | null, offerTypes: string | null, clientContactName: string | null, clientContactAddress: string | null, clientContactNumber: string | null, hasSecurity: boolean | null, terminalsCount: any | null, hasClientKkm: boolean | null, workingDays: string | null, bdoState: BdoState | null, rejectReason: string | null } } };

export type ApiKeyQueryVariables = Exact<{
  orgReferenceId: Scalars['Long']['input'];
}>;


export type ApiKeyQuery = { __typename?: 'Query', apiKey: { __typename?: 'ApiKey', createdDate: string, validUntil: string, apiKeyAccessList: Array<{ __typename?: 'ApiKeyAccess', api: string }> } };

export type CreateCashierByLinkTaskPageableQueryVariables = Exact<{
  contractId: Scalars['UUID']['input'];
  taskStates: Array<TaskStates> | TaskStates;
  pageableDecorator: InputPageable;
}>;


export type CreateCashierByLinkTaskPageableQuery = { __typename?: 'Query', createCashierByLinkTaskPageable: { __typename?: 'PageOnCreateCashierByLinkTask', totalPages: number, list: Array<{ __typename?: 'CreateCashiersByLinkTask', id: string, taskState: TaskStates, updatedBy: string, newValue: { __typename?: 'CreateCashierTaskDetails', phoneNumber: string, cashierFullName: string, salePoints: Array<{ __typename?: 'SalePointAccessDetails', salePointName: string | null, cashDetails: Array<{ __typename?: 'CashAccessDetails', cashCode: number | null }> }> } }> } };

export type CountCashierByLinkTaskPageableQueryVariables = Exact<{
  contractId: Scalars['UUID']['input'];
  taskStates: Array<TaskStates> | TaskStates;
  pageableDecorator: InputPageable;
}>;


export type CountCashierByLinkTaskPageableQuery = { __typename?: 'Query', createCashierByLinkTaskPageable: { __typename?: 'PageOnCreateCashierByLinkTask', totalElements: number } };

export type GetContractsByInnOrCompanyNameQueryVariables = Exact<{
  orgReferenceId: Scalars['Long']['input'];
  value: InputMaybe<Scalars['String']['input']>;
  pageableDecorator: InputPageable;
}>;


export type GetContractsByInnOrCompanyNameQuery = { __typename?: 'Query', getContractsByInnOrCompanyName: { __typename?: 'PageUserContractType', totalElements: number, totalPages: number, list: Array<{ __typename?: 'Contract', id: string, inn: string, active: boolean, signType: SignType, signScheme: SignScheme, companyName: string, contractNum: string, createdDate: string, departmentCode: string, departmentName: string, expirationDate: string, orgReferenceId: number, isDigital: boolean, payControlKey: { __typename?: 'PayControlKey', expirationDate: string, username: string, status: string, pcUserId: string } | null, userContractAttributes: { __typename?: 'UserContractAttributes', signRight: SignRight, registrationState: RegistrationStates, userContractState: UserContractState, userContractId: string, productRoles: Array<{ __typename?: 'ProductProjection', productName: ProductEnum, roles: ProductRoleEnum }> } | null }> } };

export type GetLegalPersonInfoQueryVariables = Exact<{
  orgReferenceId: Scalars['Long']['input'];
  reqBody: TundukLegalPersonInfoInput;
}>;


export type GetLegalPersonInfoQuery = { __typename?: 'Query', getLegalPersonInfo: { __typename?: 'TundukLegalPersonInfoType', codeDescription: string | null, traceId: string | null, codeResult: string | null, bodyResponse: { __typename?: 'TundukLegalPersonBodyResponseType', content: Array<{ __typename?: 'TundukLegalPersonContentType', id: string | null, inn: string | null, fullName: string | null, isResident: boolean | null } | null> | null, pageableData: { __typename?: 'TundukLegalPersonPageableData', pageNumber: number | null, pageSize: number | null, totalElements: number | null, totalPages: number | null } | null } | null } | null };

export type IndividualPersonQueryVariables = Exact<{
  inn: Scalars['String']['input'];
}>;


export type IndividualPersonQuery = { __typename?: 'Query', individualPerson: { __typename?: 'IndividualPerson', shortName: string, userReferenceId: number } | null };

export type MarkdownTemplateSchemasQueryVariables = Exact<{
  taskId: Scalars['UUID']['input'];
}>;


export type MarkdownTemplateSchemasQuery = { __typename?: 'Query', markdownTemplateSchemas: Array<string> };

export const ShortUserFragmentDoc = gql`
    fragment ShortUser on ShortUser {
  fullName
  signRight
}
    `;
export const PayControlKeyAvailabilityFragmentDoc = gql`
    fragment PayControlKeyAvailability on PayControlKeyAvailability {
  available
  nonAvailableFor {
    ...ShortUser
  }
  orgReferenceId
}
    ${ShortUserFragmentDoc}`;
export const PayControlKeyFragmentDoc = gql`
    fragment PayControlKey on PayControlKey {
  expirationDate
  username
  status
  pcUserId
}
    `;
export const UserContractAttributesFragmentDoc = gql`
    fragment UserContractAttributes on UserContractAttributes {
  signRight
  registrationState
  userContractState
  userContractId
  productRoles {
    productName
    roles
  }
}
    `;
export const UserContractsFragmentDoc = gql`
    fragment UserContracts on Contract {
  id
  inn
  active
  signType
  signScheme
  companyName
  contractNum
  createdDate
  departmentCode
  departmentName
  expirationDate
  orgReferenceId
  isDigital
  payControlKey {
    ...PayControlKey
  }
  userContractAttributes {
    ...UserContractAttributes
  }
}
    ${PayControlKeyFragmentDoc}
${UserContractAttributesFragmentDoc}`;
export const EmployeeFragmentDoc = gql`
    fragment Employee on Employee {
  id
  email
  mobile
  fullName
  shortName
  createdDate
  individualInn
  userReferenceId
  userContracts {
    ...UserContracts
  }
  postVerificationStatus
}
    ${UserContractsFragmentDoc}`;
export const EmployeeContractFragmentDoc = gql`
    fragment EmployeeContract on EmployeeContract {
  id
  email
  mobile
  fullName
  shortName
  signRight
  createdDate
  referenceId
  individualInn
  registrationState
  userContractState
}
    `;
export const PayControlCreateKeyFragmentDoc = gql`
    fragment PayControlCreateKey on PayControlCreateKey {
  qr
  key
  status
  username
  pcUserId
  expirationDate
}
    `;
export const LoanEmployeeFragmentDoc = gql`
    fragment LoanEmployee on LoanEmployeeState {
  totalPages
  list {
    fullName
    reason
    referenceId
    taskState
    individualInn
    createdDate
    locationId
  }
}
    `;
export const PosApplicationTypeFragmentDoc = gql`
    fragment POSApplicationType on POSApplicationType {
  legalAddress
  actualAddress
  mainActivity
  storeName
  storeAddress
  accountType
  clientAccount
  offerTypes
  clientContactName
  clientContactAddress
  clientContactNumber
  hasSecurity
  terminalsCount
  hasClientKkm
  workingDays
  bdoState
  rejectReason
}
    `;
export const PosApplicationTaskFragmentDoc = gql`
    fragment PosApplicationTask on POSApplicationTaskType {
  id
  createdDate
  newValue {
    ...POSApplicationType
  }
}
    ${PosApplicationTypeFragmentDoc}`;
export const PosApplicationTaskBriefFragmentDoc = gql`
    fragment PosApplicationTaskBrief on POSApplicationTaskType {
  id
  createdDate
  newValue {
    storeName
    terminalsCount
    bdoState
  }
}
    `;
export const PageOnPosTaskFragmentDoc = gql`
    fragment PageOnPosTask on PageOnPOSApplicationTask {
  list {
    ...PosApplicationTaskBrief
  }
  totalPages
  totalElements
}
    ${PosApplicationTaskBriefFragmentDoc}`;
export const CreateApiKeyFragmentDoc = gql`
    fragment CreateApiKey on CreatedApiKey {
  validUntil
  key
  apiKeyAccessList {
    api
  }
}
    `;
export const ApiKeyFragmentDoc = gql`
    fragment ApiKey on ApiKey {
  createdDate
  validUntil
  apiKeyAccessList {
    api
  }
}
    `;
export const PageOnCreateCashierByLinkTaskFragmentDoc = gql`
    fragment PageOnCreateCashierByLinkTask on PageOnCreateCashierByLinkTask {
  list {
    newValue {
      phoneNumber
      cashierFullName
      salePoints {
        salePointName
        cashDetails {
          cashCode
        }
      }
    }
    id
    taskState
    updatedBy
  }
  totalPages
}
    `;
export const CountCreateCashierByLinkTaskFragmentDoc = gql`
    fragment CountCreateCashierByLinkTask on PageOnCreateCashierByLinkTask {
  totalElements
}
    `;
export const PageUserContractsFragmentDoc = gql`
    fragment PageUserContracts on PageUserContractType {
  totalElements
  totalPages
  list {
    ...UserContracts
  }
}
    ${UserContractsFragmentDoc}`;
export const TundukLegalPersonContentFragmentDoc = gql`
    fragment TundukLegalPersonContent on TundukLegalPersonContentType {
  id
  inn
  fullName
  isResident
}
    `;
export const TundukLegalPersonPageableDataFragmentDoc = gql`
    fragment TundukLegalPersonPageableData on TundukLegalPersonPageableData {
  pageNumber
  pageSize
  totalElements
  totalPages
}
    `;
export const TundukLegalPersonBodyResponseFragmentDoc = gql`
    fragment TundukLegalPersonBodyResponse on TundukLegalPersonBodyResponseType {
  content {
    ...TundukLegalPersonContent
  }
  pageableData {
    ...TundukLegalPersonPageableData
  }
}
    ${TundukLegalPersonContentFragmentDoc}
${TundukLegalPersonPageableDataFragmentDoc}`;
export const TundukLegalPersonInfoFragmentDoc = gql`
    fragment TundukLegalPersonInfo on TundukLegalPersonInfoType {
  codeDescription
  traceId
  codeResult
  bodyResponse {
    ...TundukLegalPersonBodyResponse
  }
}
    ${TundukLegalPersonBodyResponseFragmentDoc}`;
export const CreateBusinessUserContractWithRoleSellerTaskDocument = gql`
    mutation createBusinessUserContractWithRoleSellerTask($userInfo: InputUserInfoRecord!, $orgReferenceId: Long!) {
  createBusinessUserContractWithRoleSellerTask(
    userInfo: $userInfo
    orgReferenceId: $orgReferenceId
  )
}
    `;
export const SavePosApplicationTaskDocument = gql`
    mutation savePosApplicationTask($businessUserContractId: UUID!, $posApplication: POSApplication!) {
  POSApplicationTask(
    businessUserContractId: $businessUserContractId
    posApplication: $posApplication
  )
}
    `;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($orgReferenceId: Long!, $password: String!, $apiKeyAccessList: [ApiKeyAccessInput!]!) {
  createApiKey(
    orgReferenceId: $orgReferenceId
    password: $password
    apiKeyAccessList: $apiKeyAccessList
  ) {
    ...CreateApiKey
  }
}
    ${CreateApiKeyFragmentDoc}`;
export const SavePayDaApplicationTaskDocument = gql`
    mutation savePayDaApplicationTask($businessUserContractId: UUID!, $payDaApplication: PayDaApplicationDto!) {
  payDaApplicationTask(
    businessUserContractId: $businessUserContractId
    payDaApplication: $payDaApplication
  )
}
    `;
export const SwitchProductRolePolicyDocument = gql`
    mutation switchProductRolePolicy($businessUserContractId: UUID!, $productRole: ProductRoleEnum!, $switchAccess: Boolean!) {
  switchProductRolePolicy(
    businessUserContractId: $businessUserContractId
    productRole: $productRole
    switchAccess: $switchAccess
  )
}
    `;
export const VerdictForTaskDocument = gql`
    mutation verdictForTask($taskId: UUID!, $verdict: Boolean!, $reason: String) {
  verdictForTask(taskId: $taskId, verdict: $verdict, reason: $reason)
}
    `;
export const CreateMarkdownDocument = gql`
    mutation createMarkdown($taskId: UUID!, $markdownTemplates: [String!]!) {
  createMarkdown(taskId: $taskId, markdownTemplates: $markdownTemplates) {
    markdowns
    markdownTemplates
  }
}
    `;
export const EmployeeSecureDocument = gql`
    query employeeSecure {
  employeeSecure {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;
export const EmployeeDocument = gql`
    query employee($userReferenceId: Long!) {
  employee(userReferenceId: $userReferenceId) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;
export const EmployeesContractDocument = gql`
    query employeesContract($orgReferenceId: Long!) {
  employeesContract(orgReferenceId: $orgReferenceId) {
    ...EmployeeContract
  }
}
    ${EmployeeContractFragmentDoc}`;
export const KeyAvailabilityDocument = gql`
    query keyAvailability($orgReferenceId: Long!) {
  keyAvailability(orgReferenceId: $orgReferenceId) {
    ...PayControlKeyAvailability
  }
}
    ${PayControlKeyAvailabilityFragmentDoc}`;
export const GetSellersDocument = gql`
    query getSellers($taskState: TaskStates!, $pageableDecorator: InputPageable!, $individualInn: String, $orgReferenceId: Long!, $taskType: [TaskType]) {
  commonTasksPageableFilter(
    individualInn: $individualInn
    pageableDecorator: $pageableDecorator
    taskState: $taskState
    orgReferenceId: $orgReferenceId
    taskType: $taskType
  ) {
    ...LoanEmployee
  }
}
    ${LoanEmployeeFragmentDoc}`;
export const UserPosApplicationTasksPageableDocument = gql`
    query userPOSApplicationTasksPageable($businessUserContractId: UUID!, $taskTypes: [TaskType!]!, $taskStates: [TaskStates!]!, $pageableDecorator: InputPageable!) {
  userPOSApplicationTasksPageable(
    businessUserContractId: $businessUserContractId
    taskTypes: $taskTypes
    taskStates: $taskStates
    pageableDecorator: $pageableDecorator
  ) {
    ...PageOnPosTask
  }
}
    ${PageOnPosTaskFragmentDoc}`;
export const GetUserPosApplicationTaskDocument = gql`
    query getUserPOSApplicationTask($taskId: UUID!, $businessUserContractId: UUID!) {
  userPOSApplicationTask(
    taskId: $taskId
    businessUserContractId: $businessUserContractId
  ) {
    ...PosApplicationTask
  }
}
    ${PosApplicationTaskFragmentDoc}`;
export const ApiKeyDocument = gql`
    query apiKey($orgReferenceId: Long!) {
  apiKey(orgReferenceId: $orgReferenceId) {
    ...ApiKey
  }
}
    ${ApiKeyFragmentDoc}`;
export const CreateCashierByLinkTaskPageableDocument = gql`
    query createCashierByLinkTaskPageable($contractId: UUID!, $taskStates: [TaskStates!]!, $pageableDecorator: InputPageable!) {
  createCashierByLinkTaskPageable(
    contractId: $contractId
    pageableDecorator: $pageableDecorator
    taskStates: $taskStates
  ) {
    ...PageOnCreateCashierByLinkTask
  }
}
    ${PageOnCreateCashierByLinkTaskFragmentDoc}`;
export const CountCashierByLinkTaskPageableDocument = gql`
    query countCashierByLinkTaskPageable($contractId: UUID!, $taskStates: [TaskStates!]!, $pageableDecorator: InputPageable!) {
  createCashierByLinkTaskPageable(
    contractId: $contractId
    pageableDecorator: $pageableDecorator
    taskStates: $taskStates
  ) {
    ...CountCreateCashierByLinkTask
  }
}
    ${CountCreateCashierByLinkTaskFragmentDoc}`;
export const GetContractsByInnOrCompanyNameDocument = gql`
    query getContractsByInnOrCompanyName($orgReferenceId: Long!, $value: String, $pageableDecorator: InputPageable!) {
  getContractsByInnOrCompanyName(
    orgReferenceId: $orgReferenceId
    value: $value
    pageableDecorator: $pageableDecorator
  ) {
    ...PageUserContracts
  }
}
    ${PageUserContractsFragmentDoc}`;
export const GetLegalPersonInfoDocument = gql`
    query getLegalPersonInfo($orgReferenceId: Long!, $reqBody: TundukLegalPersonInfoInput!) {
  getLegalPersonInfo(orgReferenceId: $orgReferenceId, reqBody: $reqBody) {
    ...TundukLegalPersonInfo
  }
}
    ${TundukLegalPersonInfoFragmentDoc}`;
export const IndividualPersonDocument = gql`
    query individualPerson($inn: String!) {
  individualPerson(inn: $inn) {
    shortName
    userReferenceId
  }
}
    `;
export const MarkdownTemplateSchemasDocument = gql`
    query markdownTemplateSchemas($taskId: UUID!) {
  markdownTemplateSchemas(taskId: $taskId)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    createBusinessUserContractWithRoleSellerTask(variables: CreateBusinessUserContractWithRoleSellerTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBusinessUserContractWithRoleSellerTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBusinessUserContractWithRoleSellerTaskMutation>(CreateBusinessUserContractWithRoleSellerTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBusinessUserContractWithRoleSellerTask', 'mutation', variables);
    },
    savePosApplicationTask(variables: SavePosApplicationTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavePosApplicationTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavePosApplicationTaskMutation>(SavePosApplicationTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'savePosApplicationTask', 'mutation', variables);
    },
    createApiKey(variables: CreateApiKeyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateApiKeyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateApiKeyMutation>(CreateApiKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createApiKey', 'mutation', variables);
    },
    savePayDaApplicationTask(variables: SavePayDaApplicationTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavePayDaApplicationTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavePayDaApplicationTaskMutation>(SavePayDaApplicationTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'savePayDaApplicationTask', 'mutation', variables);
    },
    switchProductRolePolicy(variables: SwitchProductRolePolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SwitchProductRolePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SwitchProductRolePolicyMutation>(SwitchProductRolePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'switchProductRolePolicy', 'mutation', variables);
    },
    verdictForTask(variables: VerdictForTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerdictForTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerdictForTaskMutation>(VerdictForTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verdictForTask', 'mutation', variables);
    },
    createMarkdown(variables: CreateMarkdownMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateMarkdownMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMarkdownMutation>(CreateMarkdownDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMarkdown', 'mutation', variables);
    },
    employeeSecure(variables?: EmployeeSecureQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSecureQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSecureQuery>(EmployeeSecureDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSecure', 'query', variables);
    },
    employee(variables: EmployeeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeQuery>(EmployeeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employee', 'query', variables);
    },
    employeesContract(variables: EmployeesContractQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeesContractQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeesContractQuery>(EmployeesContractDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeesContract', 'query', variables);
    },
    keyAvailability(variables: KeyAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KeyAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KeyAvailabilityQuery>(KeyAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'keyAvailability', 'query', variables);
    },
    getSellers(variables: GetSellersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSellersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSellersQuery>(GetSellersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSellers', 'query', variables);
    },
    userPOSApplicationTasksPageable(variables: UserPosApplicationTasksPageableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPosApplicationTasksPageableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPosApplicationTasksPageableQuery>(UserPosApplicationTasksPageableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPOSApplicationTasksPageable', 'query', variables);
    },
    getUserPOSApplicationTask(variables: GetUserPosApplicationTaskQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserPosApplicationTaskQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserPosApplicationTaskQuery>(GetUserPosApplicationTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserPOSApplicationTask', 'query', variables);
    },
    apiKey(variables: ApiKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApiKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApiKeyQuery>(ApiKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'apiKey', 'query', variables);
    },
    createCashierByLinkTaskPageable(variables: CreateCashierByLinkTaskPageableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCashierByLinkTaskPageableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCashierByLinkTaskPageableQuery>(CreateCashierByLinkTaskPageableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCashierByLinkTaskPageable', 'query', variables);
    },
    countCashierByLinkTaskPageable(variables: CountCashierByLinkTaskPageableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CountCashierByLinkTaskPageableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountCashierByLinkTaskPageableQuery>(CountCashierByLinkTaskPageableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'countCashierByLinkTaskPageable', 'query', variables);
    },
    getContractsByInnOrCompanyName(variables: GetContractsByInnOrCompanyNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetContractsByInnOrCompanyNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetContractsByInnOrCompanyNameQuery>(GetContractsByInnOrCompanyNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getContractsByInnOrCompanyName', 'query', variables);
    },
    getLegalPersonInfo(variables: GetLegalPersonInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLegalPersonInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLegalPersonInfoQuery>(GetLegalPersonInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLegalPersonInfo', 'query', variables);
    },
    individualPerson(variables: IndividualPersonQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IndividualPersonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IndividualPersonQuery>(IndividualPersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'individualPerson', 'query', variables);
    },
    markdownTemplateSchemas(variables: MarkdownTemplateSchemasQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkdownTemplateSchemasQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkdownTemplateSchemasQuery>(MarkdownTemplateSchemasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markdownTemplateSchemas', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;